/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'
import { createServerRootRoute } from '@tanstack/react-start/server'

import { Route as rootRouteImport } from './routes/__root'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as UserRouteImport } from './routes/_user'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as R404RouteImport } from './routes/404'
import { Route as UsernameRouteImport } from './routes/$username'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SummitIndexRouteImport } from './routes/summit/index'
import { Route as LcPaymentIndexRouteImport } from './routes/lc-payment/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as CoachUnauthenticatedRouteImport } from './routes/coach/unauthenticated'
import { Route as CoachBackendRouteImport } from './routes/coach/_backend'
import { Route as UserDashboardRouteImport } from './routes/_user/dashboard'
import { Route as UsernameResourcesRouteImport } from './routes/$username/resources'
import { Route as UsernameProfileRouteImport } from './routes/$username/_profile'
import { Route as EmbedNumberOfUsersIndexRouteImport } from './routes/embed/number-of-users/index'
import { Route as EmbedNumberOfCoachesIndexRouteImport } from './routes/embed/number-of-coaches/index'
import { Route as EmbedNewCoaches30dIndexRouteImport } from './routes/embed/new-coaches-30d/index'
import { Route as EmbedCoachLevelsIndexRouteImport } from './routes/embed/coach-levels/index'
import { Route as BlogMembersIndexRouteImport } from './routes/blog/members/index'
import { Route as BlogSlugIndexRouteImport } from './routes/blog/$slug/index'
import { Route as AdminStripeIndexRouteImport } from './routes/admin/stripe/index'
import { Route as AdminIntegrationsIndexRouteImport } from './routes/admin/integrations/index'
import { Route as AdminFinderIndexRouteImport } from './routes/admin/finder/index'
import { Route as AdminCoachesIndexRouteImport } from './routes/admin/coaches/index'
import { Route as UserSettingsIndexRouteImport } from './routes/_user/settings/index'
import { Route as UserMessagesIndexRouteImport } from './routes/_user/messages/index'
import { Route as UserCoachDiscoveryIndexRouteImport } from './routes/_user/coach-discovery/index'
import { Route as PublicDiscoveryIndexRouteImport } from './routes/_public/discovery/index'
import { Route as PublicCcosIndexRouteImport } from './routes/_public/ccos/index'
import { Route as AuthSignupIndexRouteImport } from './routes/_auth/signup/index'
import { Route as AuthSigninIndexRouteImport } from './routes/_auth/signin/index'
import { Route as AuthForgotPasswordIndexRouteImport } from './routes/_auth/forgot-password/index'
import { Route as AuthAcceptTokenIndexRouteImport } from './routes/_auth/accept-token/index'
import { Route as UsernameContactIndexRouteImport } from './routes/$username/contact/index'
import { Route as UsernameBookIndexRouteImport } from './routes/$username/book/index'
import { Route as UsernameProfileIndexRouteImport } from './routes/$username/_profile/index'
import { Route as CoachBackendMessagesRouteImport } from './routes/coach/_backend/messages'
import { Route as CoachBackendEditProfileRouteImport } from './routes/coach/_backend/edit-profile'
import { Route as UserSummitAgendaRouteImport } from './routes/_user/summit/agenda'
import { Route as UserSettingsProfileRouteImport } from './routes/_user/settings/profile'
import { Route as PublicDiscoveryStepsRouteImport } from './routes/_public/discovery/steps'
import { Route as PublicDiscoveryUsernameRouteImport } from './routes/_public/discovery/$username'
import { Route as UsernameProfileResourcesRouteImport } from './routes/$username/_profile/resources'
import { Route as CoachBackendStripeConnectIndexRouteImport } from './routes/coach/_backend/stripe-connect/index'
import { Route as CoachBackendMessagesIndexRouteImport } from './routes/coach/_backend/messages/index'
import { Route as CoachBackendMembershipPlansIndexRouteImport } from './routes/coach/_backend/membership-plans/index'
import { Route as CoachBackendInvoicesIndexRouteImport } from './routes/coach/_backend/invoices/index'
import { Route as CoachBackendEditProfileIndexRouteImport } from './routes/coach/_backend/edit-profile/index'
import { Route as CoachBackendBusinessIndexRouteImport } from './routes/coach/_backend/business/index'
import { Route as UserSettingsProfileIndexRouteImport } from './routes/_user/settings/profile/index'
import { Route as UserSettingsPasswordIndexRouteImport } from './routes/_user/settings/password/index'
import { Route as UserMessagesConversationIdIndexRouteImport } from './routes/_user/messages/$conversationId/index'
import { Route as PublicPageNameIndexRouteImport } from './routes/_public/page/$name/index'
import { Route as PublicDiscoveryStepsIndexRouteImport } from './routes/_public/discovery/steps/index'
import { Route as PublicDiscoveryUsernameIndexRouteImport } from './routes/_public/discovery/$username/index'
import { Route as PublicCoachesSubcategoryIndexRouteImport } from './routes/_public/coaches/subcategory/index'
import { Route as PublicCoachesFoundingIndexRouteImport } from './routes/_public/coaches/founding/index'
import { Route as PublicCoachesCityIndexRouteImport } from './routes/_public/coaches/city/index'
import { Route as PublicCoachesCcoIndexRouteImport } from './routes/_public/coaches/cco/index'
import { Route as PublicCoachesCategoryIndexRouteImport } from './routes/_public/coaches/category/index'
import { Route as UsernameProfileResourcesIndexRouteImport } from './routes/$username/_profile/resources/index'
import { Route as UsernameProfileOfferIndexRouteImport } from './routes/$username/_profile/offer/index'
import { Route as CoachBackendEditProfileOffersRouteImport } from './routes/coach/_backend/edit-profile/offers'
import { Route as UserSettingsProfileCoachingPreferencesRouteImport } from './routes/_user/settings/profile/coaching-preferences'
import { Route as CoachBackendMessagesConversationIdIndexRouteImport } from './routes/coach/_backend/messages/$conversationId/index'
import { Route as CoachBackendEditProfileResourcesIndexRouteImport } from './routes/coach/_backend/edit-profile/resources/index'
import { Route as CoachBackendEditProfileQualificationsIndexRouteImport } from './routes/coach/_backend/edit-profile/qualifications/index'
import { Route as CoachBackendEditProfileProfileIndexRouteImport } from './routes/coach/_backend/edit-profile/profile/index'
import { Route as CoachBackendEditProfilePersonalInfoIndexRouteImport } from './routes/coach/_backend/edit-profile/personal-info/index'
import { Route as CoachBackendEditProfileOffersIndexRouteImport } from './routes/coach/_backend/edit-profile/offers/index'
import { Route as CoachBackendEditProfileOfferIndexRouteImport } from './routes/coach/_backend/edit-profile/offer/index'
import { Route as CoachBackendEditProfileDetailsIndexRouteImport } from './routes/coach/_backend/edit-profile/details/index'
import { Route as CoachBackendEditProfileClientFlowIndexRouteImport } from './routes/coach/_backend/edit-profile/client-flow/index'
import { Route as PublicDiscoveryStepsProcessingIndexRouteImport } from './routes/_public/discovery/steps/processing/index'
import { Route as PublicDiscoverySteps9IndexRouteImport } from './routes/_public/discovery/steps/9/index'
import { Route as PublicDiscoverySteps8IndexRouteImport } from './routes/_public/discovery/steps/8/index'
import { Route as PublicDiscoverySteps7IndexRouteImport } from './routes/_public/discovery/steps/7/index'
import { Route as PublicDiscoverySteps6IndexRouteImport } from './routes/_public/discovery/steps/6/index'
import { Route as PublicDiscoverySteps5IndexRouteImport } from './routes/_public/discovery/steps/5/index'
import { Route as PublicDiscoverySteps4IndexRouteImport } from './routes/_public/discovery/steps/4/index'
import { Route as PublicDiscoverySteps3IndexRouteImport } from './routes/_public/discovery/steps/3/index'
import { Route as PublicDiscoverySteps2IndexRouteImport } from './routes/_public/discovery/steps/2/index'
import { Route as PublicDiscoverySteps10IndexRouteImport } from './routes/_public/discovery/steps/10/index'
import { Route as PublicDiscoverySteps1IndexRouteImport } from './routes/_public/discovery/steps/1/index'
import { Route as PublicDiscoveryUsernameResourcesIndexRouteImport } from './routes/_public/discovery/$username/resources/index'
import { Route as PublicDiscoveryUsernameOfferIndexRouteImport } from './routes/_public/discovery/$username/offer/index'
import { Route as PublicDiscoveryUsernameBookIndexRouteImport } from './routes/_public/discovery/$username/book/index'
import { Route as PublicCoachesSubcategorySubcategorySlugIndexRouteImport } from './routes/_public/coaches/subcategory/$subcategorySlug/index'
import { Route as PublicCoachesCitySlugIndexRouteImport } from './routes/_public/coaches/city/$slug/index'
import { Route as PublicCoachesCcoSlugIndexRouteImport } from './routes/_public/coaches/cco/$slug/index'
import { Route as PublicCoachesCategoryCategorySlugIndexRouteImport } from './routes/_public/coaches/category/$categorySlug/index'
import { Route as UsernameProfileResourcesResourceIdIndexRouteImport } from './routes/$username/_profile/resources/$resourceId/index'
import { Route as UsernameProfileOfferOfferIdIndexRouteImport } from './routes/$username/_profile/offer/$offerId/index'
import { Route as PublicSummitSummitIdSessionSessionIdRouteImport } from './routes/_public/summit/$summitId/session/$sessionId'
import { Route as CoachBackendEditProfileResourcesResourceIdIndexRouteImport } from './routes/coach/_backend/edit-profile/resources/$resourceId/index'
import { Route as CoachBackendEditProfileOffersOfferIdIndexRouteImport } from './routes/coach/_backend/edit-profile/offers/$offerId/index'
import { Route as PublicCoachesCitySlugSubcategorySubcategorySlugIndexRouteImport } from './routes/_public/coaches/city/$slug/subcategory/$subcategorySlug/index'
import { Route as PublicCoachesCitySlugCategoryCategorySlugIndexRouteImport } from './routes/_public/coaches/city/$slug/category/$categorySlug/index'
import { ServerRoute as SitemapGroupsDotxmlServerRouteImport } from './routes/sitemap-groups[.]xml'
import { ServerRoute as SitemapCoachesDotxmlServerRouteImport } from './routes/sitemap-coaches[.]xml'
import { ServerRoute as SitemapCoachesArticlesDotxmlServerRouteImport } from './routes/sitemap-coaches-articles[.]xml'
import { ServerRoute as ApiBlogCreateArticleServerRouteImport } from './routes/api/blog-create-article'
import { ServerRoute as UsernameSocialImageDotsvgServerRouteImport } from './routes/$username.social-image[.]svg'
import { ServerRoute as ApiSummitVipWebhookIndexServerRouteImport } from './routes/api/summit-vip-webhook/index'
import { ServerRoute as ApiSummitSyncIndexServerRouteImport } from './routes/api/summit-sync/index'
import { ServerRoute as ApiSummitOrderBumpWebhookIndexServerRouteImport } from './routes/api/summit-order-bump-webhook/index'
import { ServerRoute as ApiStripeWebhookDirectIndexServerRouteImport } from './routes/api/stripe-webhook-direct/index'
import { ServerRoute as ApiStripeWebhookConnectIndexServerRouteImport } from './routes/api/stripe-webhook-connect/index'
import { ServerRoute as ApiMailerliteWebhookIndexServerRouteImport } from './routes/api/mailerlite-webhook/index'
import { ServerRoute as ApiGhlSummitRegistrationIndexServerRouteImport } from './routes/api/ghl-summit-registration/index'
import { ServerRoute as ApiGhlSetUserPermissionsIndexServerRouteImport } from './routes/api/ghl-set-user-permissions/index'
import { ServerRoute as ApiGhlPermanentlyDeleteProfileIndexServerRouteImport } from './routes/api/ghl-permanently-delete-profile/index'
import { ServerRoute as ApiGhlMailerliteUnsubscribeIndexServerRouteImport } from './routes/api/ghl-mailerlite-unsubscribe/index'
import { ServerRoute as ApiGhlEnableSaasIndexServerRouteImport } from './routes/api/ghl-enable-saas/index'
import { ServerRoute as ApiGhlDeletePreProfileIndexServerRouteImport } from './routes/api/ghl-delete-pre-profile/index'
import { ServerRoute as ApiGhlCreateAccountIndexServerRouteImport } from './routes/api/ghl-create-account/index'
import { ServerRoute as ApiGhlContractSignedIndexServerRouteImport } from './routes/api/ghl-contract-signed/index'
import { ServerRoute as ApiGhlCoachStatusIndexServerRouteImport } from './routes/api/ghl-coach-status/index'
import { ServerRoute as ApiGenerateProfileIndexServerRouteImport } from './routes/api/generate-profile/index'
import { ServerRoute as ApiCoachPreProfileIndexServerRouteImport } from './routes/api/coach-pre-profile/index'
import { ServerRoute as ApiCoachJoinedCommunityIndexServerRouteImport } from './routes/api/coach-joined-community/index'
import { ServerRoute as ApiCoachEmbeddingsIndexServerRouteImport } from './routes/api/coach-embeddings/index'
import { ServerRoute as ApiBatchResetClosestCityIndexServerRouteImport } from './routes/api/batch-reset-closest-city/index'
import { ServerRoute as ApiBackfillExpertisesIndexServerRouteImport } from './routes/api/backfill-expertises/index'
import { ServerRoute as ApiProxyKeyIndexServerRouteImport } from './routes/api/proxy/$key/index'
import { ServerRoute as ApiLeadconnectorWebhookIndexServerRouteImport } from './routes/api/leadconnector/webhook/index'
import { ServerRoute as ApiLeadconnectorQueryIndexServerRouteImport } from './routes/api/leadconnector/query/index'
import { ServerRoute as ApiLeadconnectorOauthIndexServerRouteImport } from './routes/api/leadconnector/oauth/index'
import { ServerRoute as ApiLeadconnectorInitIndexServerRouteImport } from './routes/api/leadconnector/init/index'
import { ServerRoute as ApiLeadconnectorCreatePaymentConfigIndexServerRouteImport } from './routes/api/leadconnector/create-payment-config/index'
import { ServerRoute as PublicSummitSummitIdSessionSessionIdSocialImageDotsvgServerRouteImport } from './routes/_public/summit/$summitId/session/$sessionId.social-image[.]svg'

const CoachRouteImport = createFileRoute('/coach')()
const rootServerRouteImport = createServerRootRoute()

const CoachRoute = CoachRouteImport.update({
  id: '/coach',
  path: '/coach',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogRoute = BlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRouteImport,
} as any)
const UserRoute = UserRouteImport.update({
  id: '/_user',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const UsernameRoute = UsernameRouteImport.update({
  id: '/$username',
  path: '/$username',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SummitIndexRoute = SummitIndexRouteImport.update({
  id: '/summit/',
  path: '/summit/',
  getParentRoute: () => rootRouteImport,
} as any)
const LcPaymentIndexRoute = LcPaymentIndexRouteImport.update({
  id: '/lc-payment/',
  path: '/lc-payment/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BlogRoute,
} as any)
const CoachUnauthenticatedRoute = CoachUnauthenticatedRouteImport.update({
  id: '/unauthenticated',
  path: '/unauthenticated',
  getParentRoute: () => CoachRoute,
} as any)
const CoachBackendRoute = CoachBackendRouteImport.update({
  id: '/_backend',
  getParentRoute: () => CoachRoute,
} as any)
const UserDashboardRoute = UserDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => UserRoute,
} as any)
const UsernameResourcesRoute = UsernameResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => UsernameRoute,
} as any)
const UsernameProfileRoute = UsernameProfileRouteImport.update({
  id: '/_profile',
  getParentRoute: () => UsernameRoute,
} as any)
const EmbedNumberOfUsersIndexRoute = EmbedNumberOfUsersIndexRouteImport.update({
  id: '/embed/number-of-users/',
  path: '/embed/number-of-users/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmbedNumberOfCoachesIndexRoute =
  EmbedNumberOfCoachesIndexRouteImport.update({
    id: '/embed/number-of-coaches/',
    path: '/embed/number-of-coaches/',
    getParentRoute: () => rootRouteImport,
  } as any)
const EmbedNewCoaches30dIndexRoute = EmbedNewCoaches30dIndexRouteImport.update({
  id: '/embed/new-coaches-30d/',
  path: '/embed/new-coaches-30d/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmbedCoachLevelsIndexRoute = EmbedCoachLevelsIndexRouteImport.update({
  id: '/embed/coach-levels/',
  path: '/embed/coach-levels/',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogMembersIndexRoute = BlogMembersIndexRouteImport.update({
  id: '/members/',
  path: '/members/',
  getParentRoute: () => BlogRoute,
} as any)
const BlogSlugIndexRoute = BlogSlugIndexRouteImport.update({
  id: '/$slug/',
  path: '/$slug/',
  getParentRoute: () => BlogRoute,
} as any)
const AdminStripeIndexRoute = AdminStripeIndexRouteImport.update({
  id: '/admin/stripe/',
  path: '/admin/stripe/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIntegrationsIndexRoute = AdminIntegrationsIndexRouteImport.update({
  id: '/admin/integrations/',
  path: '/admin/integrations/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFinderIndexRoute = AdminFinderIndexRouteImport.update({
  id: '/admin/finder/',
  path: '/admin/finder/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCoachesIndexRoute = AdminCoachesIndexRouteImport.update({
  id: '/admin/coaches/',
  path: '/admin/coaches/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserSettingsIndexRoute = UserSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => UserRoute,
} as any)
const UserMessagesIndexRoute = UserMessagesIndexRouteImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => UserRoute,
} as any)
const UserCoachDiscoveryIndexRoute = UserCoachDiscoveryIndexRouteImport.update({
  id: '/coach-discovery/',
  path: '/coach-discovery/',
  getParentRoute: () => UserRoute,
} as any)
const PublicDiscoveryIndexRoute = PublicDiscoveryIndexRouteImport.update({
  id: '/discovery/',
  path: '/discovery/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicCcosIndexRoute = PublicCcosIndexRouteImport.update({
  id: '/ccos/',
  path: '/ccos/',
  getParentRoute: () => PublicRoute,
} as any)
const AuthSignupIndexRoute = AuthSignupIndexRouteImport.update({
  id: '/signup/',
  path: '/signup/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSigninIndexRoute = AuthSigninIndexRouteImport.update({
  id: '/signin/',
  path: '/signin/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordIndexRoute = AuthForgotPasswordIndexRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAcceptTokenIndexRoute = AuthAcceptTokenIndexRouteImport.update({
  id: '/accept-token/',
  path: '/accept-token/',
  getParentRoute: () => AuthRoute,
} as any)
const UsernameContactIndexRoute = UsernameContactIndexRouteImport.update({
  id: '/contact/',
  path: '/contact/',
  getParentRoute: () => UsernameRoute,
} as any)
const UsernameBookIndexRoute = UsernameBookIndexRouteImport.update({
  id: '/book/',
  path: '/book/',
  getParentRoute: () => UsernameRoute,
} as any)
const UsernameProfileIndexRoute = UsernameProfileIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UsernameProfileRoute,
} as any)
const CoachBackendMessagesRoute = CoachBackendMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => CoachBackendRoute,
} as any)
const CoachBackendEditProfileRoute = CoachBackendEditProfileRouteImport.update({
  id: '/edit-profile',
  path: '/edit-profile',
  getParentRoute: () => CoachBackendRoute,
} as any)
const UserSummitAgendaRoute = UserSummitAgendaRouteImport.update({
  id: '/summit/agenda',
  path: '/summit/agenda',
  getParentRoute: () => UserRoute,
} as any)
const UserSettingsProfileRoute = UserSettingsProfileRouteImport.update({
  id: '/settings/profile',
  path: '/settings/profile',
  getParentRoute: () => UserRoute,
} as any)
const PublicDiscoveryStepsRoute = PublicDiscoveryStepsRouteImport.update({
  id: '/discovery/steps',
  path: '/discovery/steps',
  getParentRoute: () => PublicRoute,
} as any)
const PublicDiscoveryUsernameRoute = PublicDiscoveryUsernameRouteImport.update({
  id: '/discovery/$username',
  path: '/discovery/$username',
  getParentRoute: () => PublicRoute,
} as any)
const UsernameProfileResourcesRoute =
  UsernameProfileResourcesRouteImport.update({
    id: '/resources',
    path: '/resources',
    getParentRoute: () => UsernameProfileRoute,
  } as any)
const CoachBackendStripeConnectIndexRoute =
  CoachBackendStripeConnectIndexRouteImport.update({
    id: '/stripe-connect/',
    path: '/stripe-connect/',
    getParentRoute: () => CoachBackendRoute,
  } as any)
const CoachBackendMessagesIndexRoute =
  CoachBackendMessagesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CoachBackendMessagesRoute,
  } as any)
const CoachBackendMembershipPlansIndexRoute =
  CoachBackendMembershipPlansIndexRouteImport.update({
    id: '/membership-plans/',
    path: '/membership-plans/',
    getParentRoute: () => CoachBackendRoute,
  } as any)
const CoachBackendInvoicesIndexRoute =
  CoachBackendInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => CoachBackendRoute,
  } as any)
const CoachBackendEditProfileIndexRoute =
  CoachBackendEditProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CoachBackendEditProfileRoute,
  } as any)
const CoachBackendBusinessIndexRoute =
  CoachBackendBusinessIndexRouteImport.update({
    id: '/business/',
    path: '/business/',
    getParentRoute: () => CoachBackendRoute,
  } as any)
const UserSettingsProfileIndexRoute =
  UserSettingsProfileIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => UserSettingsProfileRoute,
  } as any)
const UserSettingsPasswordIndexRoute =
  UserSettingsPasswordIndexRouteImport.update({
    id: '/settings/password/',
    path: '/settings/password/',
    getParentRoute: () => UserRoute,
  } as any)
const UserMessagesConversationIdIndexRoute =
  UserMessagesConversationIdIndexRouteImport.update({
    id: '/messages/$conversationId/',
    path: '/messages/$conversationId/',
    getParentRoute: () => UserRoute,
  } as any)
const PublicPageNameIndexRoute = PublicPageNameIndexRouteImport.update({
  id: '/page/$name/',
  path: '/page/$name/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicDiscoveryStepsIndexRoute =
  PublicDiscoveryStepsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PublicDiscoveryStepsRoute,
  } as any)
const PublicDiscoveryUsernameIndexRoute =
  PublicDiscoveryUsernameIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PublicDiscoveryUsernameRoute,
  } as any)
const PublicCoachesSubcategoryIndexRoute =
  PublicCoachesSubcategoryIndexRouteImport.update({
    id: '/coaches/subcategory/',
    path: '/coaches/subcategory/',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicCoachesFoundingIndexRoute =
  PublicCoachesFoundingIndexRouteImport.update({
    id: '/coaches/founding/',
    path: '/coaches/founding/',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicCoachesCityIndexRoute = PublicCoachesCityIndexRouteImport.update({
  id: '/coaches/city/',
  path: '/coaches/city/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicCoachesCcoIndexRoute = PublicCoachesCcoIndexRouteImport.update({
  id: '/coaches/cco/',
  path: '/coaches/cco/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicCoachesCategoryIndexRoute =
  PublicCoachesCategoryIndexRouteImport.update({
    id: '/coaches/category/',
    path: '/coaches/category/',
    getParentRoute: () => PublicRoute,
  } as any)
const UsernameProfileResourcesIndexRoute =
  UsernameProfileResourcesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => UsernameProfileResourcesRoute,
  } as any)
const UsernameProfileOfferIndexRoute =
  UsernameProfileOfferIndexRouteImport.update({
    id: '/offer/',
    path: '/offer/',
    getParentRoute: () => UsernameProfileRoute,
  } as any)
const CoachBackendEditProfileOffersRoute =
  CoachBackendEditProfileOffersRouteImport.update({
    id: '/offers',
    path: '/offers',
    getParentRoute: () => CoachBackendEditProfileRoute,
  } as any)
const UserSettingsProfileCoachingPreferencesRoute =
  UserSettingsProfileCoachingPreferencesRouteImport.update({
    id: '/coaching-preferences',
    path: '/coaching-preferences',
    getParentRoute: () => UserSettingsProfileRoute,
  } as any)
const CoachBackendMessagesConversationIdIndexRoute =
  CoachBackendMessagesConversationIdIndexRouteImport.update({
    id: '/$conversationId/',
    path: '/$conversationId/',
    getParentRoute: () => CoachBackendMessagesRoute,
  } as any)
const CoachBackendEditProfileResourcesIndexRoute =
  CoachBackendEditProfileResourcesIndexRouteImport.update({
    id: '/resources/',
    path: '/resources/',
    getParentRoute: () => CoachBackendEditProfileRoute,
  } as any)
const CoachBackendEditProfileQualificationsIndexRoute =
  CoachBackendEditProfileQualificationsIndexRouteImport.update({
    id: '/qualifications/',
    path: '/qualifications/',
    getParentRoute: () => CoachBackendEditProfileRoute,
  } as any)
const CoachBackendEditProfileProfileIndexRoute =
  CoachBackendEditProfileProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => CoachBackendEditProfileRoute,
  } as any)
const CoachBackendEditProfilePersonalInfoIndexRoute =
  CoachBackendEditProfilePersonalInfoIndexRouteImport.update({
    id: '/personal-info/',
    path: '/personal-info/',
    getParentRoute: () => CoachBackendEditProfileRoute,
  } as any)
const CoachBackendEditProfileOffersIndexRoute =
  CoachBackendEditProfileOffersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CoachBackendEditProfileOffersRoute,
  } as any)
const CoachBackendEditProfileOfferIndexRoute =
  CoachBackendEditProfileOfferIndexRouteImport.update({
    id: '/offer/',
    path: '/offer/',
    getParentRoute: () => CoachBackendEditProfileRoute,
  } as any)
const CoachBackendEditProfileDetailsIndexRoute =
  CoachBackendEditProfileDetailsIndexRouteImport.update({
    id: '/details/',
    path: '/details/',
    getParentRoute: () => CoachBackendEditProfileRoute,
  } as any)
const CoachBackendEditProfileClientFlowIndexRoute =
  CoachBackendEditProfileClientFlowIndexRouteImport.update({
    id: '/client-flow/',
    path: '/client-flow/',
    getParentRoute: () => CoachBackendEditProfileRoute,
  } as any)
const PublicDiscoveryStepsProcessingIndexRoute =
  PublicDiscoveryStepsProcessingIndexRouteImport.update({
    id: '/processing/',
    path: '/processing/',
    getParentRoute: () => PublicDiscoveryStepsRoute,
  } as any)
const PublicDiscoverySteps9IndexRoute =
  PublicDiscoverySteps9IndexRouteImport.update({
    id: '/9/',
    path: '/9/',
    getParentRoute: () => PublicDiscoveryStepsRoute,
  } as any)
const PublicDiscoverySteps8IndexRoute =
  PublicDiscoverySteps8IndexRouteImport.update({
    id: '/8/',
    path: '/8/',
    getParentRoute: () => PublicDiscoveryStepsRoute,
  } as any)
const PublicDiscoverySteps7IndexRoute =
  PublicDiscoverySteps7IndexRouteImport.update({
    id: '/7/',
    path: '/7/',
    getParentRoute: () => PublicDiscoveryStepsRoute,
  } as any)
const PublicDiscoverySteps6IndexRoute =
  PublicDiscoverySteps6IndexRouteImport.update({
    id: '/6/',
    path: '/6/',
    getParentRoute: () => PublicDiscoveryStepsRoute,
  } as any)
const PublicDiscoverySteps5IndexRoute =
  PublicDiscoverySteps5IndexRouteImport.update({
    id: '/5/',
    path: '/5/',
    getParentRoute: () => PublicDiscoveryStepsRoute,
  } as any)
const PublicDiscoverySteps4IndexRoute =
  PublicDiscoverySteps4IndexRouteImport.update({
    id: '/4/',
    path: '/4/',
    getParentRoute: () => PublicDiscoveryStepsRoute,
  } as any)
const PublicDiscoverySteps3IndexRoute =
  PublicDiscoverySteps3IndexRouteImport.update({
    id: '/3/',
    path: '/3/',
    getParentRoute: () => PublicDiscoveryStepsRoute,
  } as any)
const PublicDiscoverySteps2IndexRoute =
  PublicDiscoverySteps2IndexRouteImport.update({
    id: '/2/',
    path: '/2/',
    getParentRoute: () => PublicDiscoveryStepsRoute,
  } as any)
const PublicDiscoverySteps10IndexRoute =
  PublicDiscoverySteps10IndexRouteImport.update({
    id: '/10/',
    path: '/10/',
    getParentRoute: () => PublicDiscoveryStepsRoute,
  } as any)
const PublicDiscoverySteps1IndexRoute =
  PublicDiscoverySteps1IndexRouteImport.update({
    id: '/1/',
    path: '/1/',
    getParentRoute: () => PublicDiscoveryStepsRoute,
  } as any)
const PublicDiscoveryUsernameResourcesIndexRoute =
  PublicDiscoveryUsernameResourcesIndexRouteImport.update({
    id: '/resources/',
    path: '/resources/',
    getParentRoute: () => PublicDiscoveryUsernameRoute,
  } as any)
const PublicDiscoveryUsernameOfferIndexRoute =
  PublicDiscoveryUsernameOfferIndexRouteImport.update({
    id: '/offer/',
    path: '/offer/',
    getParentRoute: () => PublicDiscoveryUsernameRoute,
  } as any)
const PublicDiscoveryUsernameBookIndexRoute =
  PublicDiscoveryUsernameBookIndexRouteImport.update({
    id: '/book/',
    path: '/book/',
    getParentRoute: () => PublicDiscoveryUsernameRoute,
  } as any)
const PublicCoachesSubcategorySubcategorySlugIndexRoute =
  PublicCoachesSubcategorySubcategorySlugIndexRouteImport.update({
    id: '/coaches/subcategory/$subcategorySlug/',
    path: '/coaches/subcategory/$subcategorySlug/',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicCoachesCitySlugIndexRoute =
  PublicCoachesCitySlugIndexRouteImport.update({
    id: '/coaches/city/$slug/',
    path: '/coaches/city/$slug/',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicCoachesCcoSlugIndexRoute =
  PublicCoachesCcoSlugIndexRouteImport.update({
    id: '/coaches/cco/$slug/',
    path: '/coaches/cco/$slug/',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicCoachesCategoryCategorySlugIndexRoute =
  PublicCoachesCategoryCategorySlugIndexRouteImport.update({
    id: '/coaches/category/$categorySlug/',
    path: '/coaches/category/$categorySlug/',
    getParentRoute: () => PublicRoute,
  } as any)
const UsernameProfileResourcesResourceIdIndexRoute =
  UsernameProfileResourcesResourceIdIndexRouteImport.update({
    id: '/$resourceId/',
    path: '/$resourceId/',
    getParentRoute: () => UsernameProfileResourcesRoute,
  } as any)
const UsernameProfileOfferOfferIdIndexRoute =
  UsernameProfileOfferOfferIdIndexRouteImport.update({
    id: '/offer/$offerId/',
    path: '/offer/$offerId/',
    getParentRoute: () => UsernameProfileRoute,
  } as any)
const PublicSummitSummitIdSessionSessionIdRoute =
  PublicSummitSummitIdSessionSessionIdRouteImport.update({
    id: '/summit/$summitId/session/$sessionId',
    path: '/summit/$summitId/session/$sessionId',
    getParentRoute: () => PublicRoute,
  } as any)
const CoachBackendEditProfileResourcesResourceIdIndexRoute =
  CoachBackendEditProfileResourcesResourceIdIndexRouteImport.update({
    id: '/resources/$resourceId/',
    path: '/resources/$resourceId/',
    getParentRoute: () => CoachBackendEditProfileRoute,
  } as any)
const CoachBackendEditProfileOffersOfferIdIndexRoute =
  CoachBackendEditProfileOffersOfferIdIndexRouteImport.update({
    id: '/$offerId/',
    path: '/$offerId/',
    getParentRoute: () => CoachBackendEditProfileOffersRoute,
  } as any)
const PublicCoachesCitySlugSubcategorySubcategorySlugIndexRoute =
  PublicCoachesCitySlugSubcategorySubcategorySlugIndexRouteImport.update({
    id: '/coaches/city/$slug/subcategory/$subcategorySlug/',
    path: '/coaches/city/$slug/subcategory/$subcategorySlug/',
    getParentRoute: () => PublicRoute,
  } as any)
const PublicCoachesCitySlugCategoryCategorySlugIndexRoute =
  PublicCoachesCitySlugCategoryCategorySlugIndexRouteImport.update({
    id: '/coaches/city/$slug/category/$categorySlug/',
    path: '/coaches/city/$slug/category/$categorySlug/',
    getParentRoute: () => PublicRoute,
  } as any)
const SitemapGroupsDotxmlServerRoute =
  SitemapGroupsDotxmlServerRouteImport.update({
    id: '/sitemap-groups.xml',
    path: '/sitemap-groups.xml',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const SitemapCoachesDotxmlServerRoute =
  SitemapCoachesDotxmlServerRouteImport.update({
    id: '/sitemap-coaches.xml',
    path: '/sitemap-coaches.xml',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const SitemapCoachesArticlesDotxmlServerRoute =
  SitemapCoachesArticlesDotxmlServerRouteImport.update({
    id: '/sitemap-coaches-articles.xml',
    path: '/sitemap-coaches-articles.xml',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiBlogCreateArticleServerRoute =
  ApiBlogCreateArticleServerRouteImport.update({
    id: '/api/blog-create-article',
    path: '/api/blog-create-article',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const UsernameSocialImageDotsvgServerRoute =
  UsernameSocialImageDotsvgServerRouteImport.update({
    id: '/$username/social-image.svg',
    path: '/$username/social-image.svg',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiSummitVipWebhookIndexServerRoute =
  ApiSummitVipWebhookIndexServerRouteImport.update({
    id: '/api/summit-vip-webhook/',
    path: '/api/summit-vip-webhook/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiSummitSyncIndexServerRoute =
  ApiSummitSyncIndexServerRouteImport.update({
    id: '/api/summit-sync/',
    path: '/api/summit-sync/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiSummitOrderBumpWebhookIndexServerRoute =
  ApiSummitOrderBumpWebhookIndexServerRouteImport.update({
    id: '/api/summit-order-bump-webhook/',
    path: '/api/summit-order-bump-webhook/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiStripeWebhookDirectIndexServerRoute =
  ApiStripeWebhookDirectIndexServerRouteImport.update({
    id: '/api/stripe-webhook-direct/',
    path: '/api/stripe-webhook-direct/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiStripeWebhookConnectIndexServerRoute =
  ApiStripeWebhookConnectIndexServerRouteImport.update({
    id: '/api/stripe-webhook-connect/',
    path: '/api/stripe-webhook-connect/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiMailerliteWebhookIndexServerRoute =
  ApiMailerliteWebhookIndexServerRouteImport.update({
    id: '/api/mailerlite-webhook/',
    path: '/api/mailerlite-webhook/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiGhlSummitRegistrationIndexServerRoute =
  ApiGhlSummitRegistrationIndexServerRouteImport.update({
    id: '/api/ghl-summit-registration/',
    path: '/api/ghl-summit-registration/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiGhlSetUserPermissionsIndexServerRoute =
  ApiGhlSetUserPermissionsIndexServerRouteImport.update({
    id: '/api/ghl-set-user-permissions/',
    path: '/api/ghl-set-user-permissions/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiGhlPermanentlyDeleteProfileIndexServerRoute =
  ApiGhlPermanentlyDeleteProfileIndexServerRouteImport.update({
    id: '/api/ghl-permanently-delete-profile/',
    path: '/api/ghl-permanently-delete-profile/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiGhlMailerliteUnsubscribeIndexServerRoute =
  ApiGhlMailerliteUnsubscribeIndexServerRouteImport.update({
    id: '/api/ghl-mailerlite-unsubscribe/',
    path: '/api/ghl-mailerlite-unsubscribe/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiGhlEnableSaasIndexServerRoute =
  ApiGhlEnableSaasIndexServerRouteImport.update({
    id: '/api/ghl-enable-saas/',
    path: '/api/ghl-enable-saas/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiGhlDeletePreProfileIndexServerRoute =
  ApiGhlDeletePreProfileIndexServerRouteImport.update({
    id: '/api/ghl-delete-pre-profile/',
    path: '/api/ghl-delete-pre-profile/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiGhlCreateAccountIndexServerRoute =
  ApiGhlCreateAccountIndexServerRouteImport.update({
    id: '/api/ghl-create-account/',
    path: '/api/ghl-create-account/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiGhlContractSignedIndexServerRoute =
  ApiGhlContractSignedIndexServerRouteImport.update({
    id: '/api/ghl-contract-signed/',
    path: '/api/ghl-contract-signed/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiGhlCoachStatusIndexServerRoute =
  ApiGhlCoachStatusIndexServerRouteImport.update({
    id: '/api/ghl-coach-status/',
    path: '/api/ghl-coach-status/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiGenerateProfileIndexServerRoute =
  ApiGenerateProfileIndexServerRouteImport.update({
    id: '/api/generate-profile/',
    path: '/api/generate-profile/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiCoachPreProfileIndexServerRoute =
  ApiCoachPreProfileIndexServerRouteImport.update({
    id: '/api/coach-pre-profile/',
    path: '/api/coach-pre-profile/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiCoachJoinedCommunityIndexServerRoute =
  ApiCoachJoinedCommunityIndexServerRouteImport.update({
    id: '/api/coach-joined-community/',
    path: '/api/coach-joined-community/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiCoachEmbeddingsIndexServerRoute =
  ApiCoachEmbeddingsIndexServerRouteImport.update({
    id: '/api/coach-embeddings/',
    path: '/api/coach-embeddings/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiBatchResetClosestCityIndexServerRoute =
  ApiBatchResetClosestCityIndexServerRouteImport.update({
    id: '/api/batch-reset-closest-city/',
    path: '/api/batch-reset-closest-city/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiBackfillExpertisesIndexServerRoute =
  ApiBackfillExpertisesIndexServerRouteImport.update({
    id: '/api/backfill-expertises/',
    path: '/api/backfill-expertises/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiProxyKeyIndexServerRoute = ApiProxyKeyIndexServerRouteImport.update({
  id: '/api/proxy/$key/',
  path: '/api/proxy/$key/',
  getParentRoute: () => rootServerRouteImport,
} as any)
const ApiLeadconnectorWebhookIndexServerRoute =
  ApiLeadconnectorWebhookIndexServerRouteImport.update({
    id: '/api/leadconnector/webhook/',
    path: '/api/leadconnector/webhook/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiLeadconnectorQueryIndexServerRoute =
  ApiLeadconnectorQueryIndexServerRouteImport.update({
    id: '/api/leadconnector/query/',
    path: '/api/leadconnector/query/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiLeadconnectorOauthIndexServerRoute =
  ApiLeadconnectorOauthIndexServerRouteImport.update({
    id: '/api/leadconnector/oauth/',
    path: '/api/leadconnector/oauth/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiLeadconnectorInitIndexServerRoute =
  ApiLeadconnectorInitIndexServerRouteImport.update({
    id: '/api/leadconnector/init/',
    path: '/api/leadconnector/init/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const ApiLeadconnectorCreatePaymentConfigIndexServerRoute =
  ApiLeadconnectorCreatePaymentConfigIndexServerRouteImport.update({
    id: '/api/leadconnector/create-payment-config/',
    path: '/api/leadconnector/create-payment-config/',
    getParentRoute: () => rootServerRouteImport,
  } as any)
const PublicSummitSummitIdSessionSessionIdSocialImageDotsvgServerRoute =
  PublicSummitSummitIdSessionSessionIdSocialImageDotsvgServerRouteImport.update(
    {
      id: '/_public/summit/$summitId/session/$sessionId/social-image.svg',
      path: '/summit/$summitId/session/$sessionId/social-image.svg',
      getParentRoute: () => rootServerRouteImport,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$username': typeof UsernameProfileRouteWithChildren
  '/404': typeof R404Route
  '/blog': typeof BlogRouteWithChildren
  '/$username/resources': typeof UsernameProfileResourcesRouteWithChildren
  '/dashboard': typeof UserDashboardRoute
  '/coach': typeof CoachBackendRouteWithChildren
  '/coach/unauthenticated': typeof CoachUnauthenticatedRoute
  '/blog/': typeof BlogIndexRoute
  '/lc-payment': typeof LcPaymentIndexRoute
  '/summit': typeof SummitIndexRoute
  '/discovery/$username': typeof PublicDiscoveryUsernameRouteWithChildren
  '/discovery/steps': typeof PublicDiscoveryStepsRouteWithChildren
  '/settings/profile': typeof UserSettingsProfileRouteWithChildren
  '/summit/agenda': typeof UserSummitAgendaRoute
  '/coach/edit-profile': typeof CoachBackendEditProfileRouteWithChildren
  '/coach/messages': typeof CoachBackendMessagesRouteWithChildren
  '/$username/': typeof UsernameProfileIndexRoute
  '/$username/book': typeof UsernameBookIndexRoute
  '/$username/contact': typeof UsernameContactIndexRoute
  '/accept-token': typeof AuthAcceptTokenIndexRoute
  '/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/signin': typeof AuthSigninIndexRoute
  '/signup': typeof AuthSignupIndexRoute
  '/ccos': typeof PublicCcosIndexRoute
  '/discovery': typeof PublicDiscoveryIndexRoute
  '/coach-discovery': typeof UserCoachDiscoveryIndexRoute
  '/messages': typeof UserMessagesIndexRoute
  '/settings': typeof UserSettingsIndexRoute
  '/admin/coaches': typeof AdminCoachesIndexRoute
  '/admin/finder': typeof AdminFinderIndexRoute
  '/admin/integrations': typeof AdminIntegrationsIndexRoute
  '/admin/stripe': typeof AdminStripeIndexRoute
  '/blog/$slug': typeof BlogSlugIndexRoute
  '/blog/members': typeof BlogMembersIndexRoute
  '/embed/coach-levels': typeof EmbedCoachLevelsIndexRoute
  '/embed/new-coaches-30d': typeof EmbedNewCoaches30dIndexRoute
  '/embed/number-of-coaches': typeof EmbedNumberOfCoachesIndexRoute
  '/embed/number-of-users': typeof EmbedNumberOfUsersIndexRoute
  '/settings/profile/coaching-preferences': typeof UserSettingsProfileCoachingPreferencesRoute
  '/coach/edit-profile/offers': typeof CoachBackendEditProfileOffersRouteWithChildren
  '/$username/offer': typeof UsernameProfileOfferIndexRoute
  '/$username/resources/': typeof UsernameProfileResourcesIndexRoute
  '/coaches/category': typeof PublicCoachesCategoryIndexRoute
  '/coaches/cco': typeof PublicCoachesCcoIndexRoute
  '/coaches/city': typeof PublicCoachesCityIndexRoute
  '/coaches/founding': typeof PublicCoachesFoundingIndexRoute
  '/coaches/subcategory': typeof PublicCoachesSubcategoryIndexRoute
  '/discovery/$username/': typeof PublicDiscoveryUsernameIndexRoute
  '/discovery/steps/': typeof PublicDiscoveryStepsIndexRoute
  '/page/$name': typeof PublicPageNameIndexRoute
  '/messages/$conversationId': typeof UserMessagesConversationIdIndexRoute
  '/settings/password': typeof UserSettingsPasswordIndexRoute
  '/settings/profile/': typeof UserSettingsProfileIndexRoute
  '/coach/business': typeof CoachBackendBusinessIndexRoute
  '/coach/edit-profile/': typeof CoachBackendEditProfileIndexRoute
  '/coach/invoices': typeof CoachBackendInvoicesIndexRoute
  '/coach/membership-plans': typeof CoachBackendMembershipPlansIndexRoute
  '/coach/messages/': typeof CoachBackendMessagesIndexRoute
  '/coach/stripe-connect': typeof CoachBackendStripeConnectIndexRoute
  '/summit/$summitId/session/$sessionId': typeof PublicSummitSummitIdSessionSessionIdRoute
  '/$username/offer/$offerId': typeof UsernameProfileOfferOfferIdIndexRoute
  '/$username/resources/$resourceId': typeof UsernameProfileResourcesResourceIdIndexRoute
  '/coaches/category/$categorySlug': typeof PublicCoachesCategoryCategorySlugIndexRoute
  '/coaches/cco/$slug': typeof PublicCoachesCcoSlugIndexRoute
  '/coaches/city/$slug': typeof PublicCoachesCitySlugIndexRoute
  '/coaches/subcategory/$subcategorySlug': typeof PublicCoachesSubcategorySubcategorySlugIndexRoute
  '/discovery/$username/book': typeof PublicDiscoveryUsernameBookIndexRoute
  '/discovery/$username/offer': typeof PublicDiscoveryUsernameOfferIndexRoute
  '/discovery/$username/resources': typeof PublicDiscoveryUsernameResourcesIndexRoute
  '/discovery/steps/1': typeof PublicDiscoverySteps1IndexRoute
  '/discovery/steps/10': typeof PublicDiscoverySteps10IndexRoute
  '/discovery/steps/2': typeof PublicDiscoverySteps2IndexRoute
  '/discovery/steps/3': typeof PublicDiscoverySteps3IndexRoute
  '/discovery/steps/4': typeof PublicDiscoverySteps4IndexRoute
  '/discovery/steps/5': typeof PublicDiscoverySteps5IndexRoute
  '/discovery/steps/6': typeof PublicDiscoverySteps6IndexRoute
  '/discovery/steps/7': typeof PublicDiscoverySteps7IndexRoute
  '/discovery/steps/8': typeof PublicDiscoverySteps8IndexRoute
  '/discovery/steps/9': typeof PublicDiscoverySteps9IndexRoute
  '/discovery/steps/processing': typeof PublicDiscoveryStepsProcessingIndexRoute
  '/coach/edit-profile/client-flow': typeof CoachBackendEditProfileClientFlowIndexRoute
  '/coach/edit-profile/details': typeof CoachBackendEditProfileDetailsIndexRoute
  '/coach/edit-profile/offer': typeof CoachBackendEditProfileOfferIndexRoute
  '/coach/edit-profile/offers/': typeof CoachBackendEditProfileOffersIndexRoute
  '/coach/edit-profile/personal-info': typeof CoachBackendEditProfilePersonalInfoIndexRoute
  '/coach/edit-profile/profile': typeof CoachBackendEditProfileProfileIndexRoute
  '/coach/edit-profile/qualifications': typeof CoachBackendEditProfileQualificationsIndexRoute
  '/coach/edit-profile/resources': typeof CoachBackendEditProfileResourcesIndexRoute
  '/coach/messages/$conversationId': typeof CoachBackendMessagesConversationIdIndexRoute
  '/coach/edit-profile/offers/$offerId': typeof CoachBackendEditProfileOffersOfferIdIndexRoute
  '/coach/edit-profile/resources/$resourceId': typeof CoachBackendEditProfileResourcesResourceIdIndexRoute
  '/coaches/city/$slug/category/$categorySlug': typeof PublicCoachesCitySlugCategoryCategorySlugIndexRoute
  '/coaches/city/$slug/subcategory/$subcategorySlug': typeof PublicCoachesCitySlugSubcategorySubcategorySlugIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$username': typeof UsernameProfileIndexRoute
  '/404': typeof R404Route
  '/$username/resources': typeof UsernameProfileResourcesIndexRoute
  '/dashboard': typeof UserDashboardRoute
  '/coach': typeof CoachBackendRouteWithChildren
  '/coach/unauthenticated': typeof CoachUnauthenticatedRoute
  '/blog': typeof BlogIndexRoute
  '/lc-payment': typeof LcPaymentIndexRoute
  '/summit': typeof SummitIndexRoute
  '/summit/agenda': typeof UserSummitAgendaRoute
  '/$username/book': typeof UsernameBookIndexRoute
  '/$username/contact': typeof UsernameContactIndexRoute
  '/accept-token': typeof AuthAcceptTokenIndexRoute
  '/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/signin': typeof AuthSigninIndexRoute
  '/signup': typeof AuthSignupIndexRoute
  '/ccos': typeof PublicCcosIndexRoute
  '/discovery': typeof PublicDiscoveryIndexRoute
  '/coach-discovery': typeof UserCoachDiscoveryIndexRoute
  '/messages': typeof UserMessagesIndexRoute
  '/settings': typeof UserSettingsIndexRoute
  '/admin/coaches': typeof AdminCoachesIndexRoute
  '/admin/finder': typeof AdminFinderIndexRoute
  '/admin/integrations': typeof AdminIntegrationsIndexRoute
  '/admin/stripe': typeof AdminStripeIndexRoute
  '/blog/$slug': typeof BlogSlugIndexRoute
  '/blog/members': typeof BlogMembersIndexRoute
  '/embed/coach-levels': typeof EmbedCoachLevelsIndexRoute
  '/embed/new-coaches-30d': typeof EmbedNewCoaches30dIndexRoute
  '/embed/number-of-coaches': typeof EmbedNumberOfCoachesIndexRoute
  '/embed/number-of-users': typeof EmbedNumberOfUsersIndexRoute
  '/settings/profile/coaching-preferences': typeof UserSettingsProfileCoachingPreferencesRoute
  '/$username/offer': typeof UsernameProfileOfferIndexRoute
  '/coaches/category': typeof PublicCoachesCategoryIndexRoute
  '/coaches/cco': typeof PublicCoachesCcoIndexRoute
  '/coaches/city': typeof PublicCoachesCityIndexRoute
  '/coaches/founding': typeof PublicCoachesFoundingIndexRoute
  '/coaches/subcategory': typeof PublicCoachesSubcategoryIndexRoute
  '/discovery/$username': typeof PublicDiscoveryUsernameIndexRoute
  '/discovery/steps': typeof PublicDiscoveryStepsIndexRoute
  '/page/$name': typeof PublicPageNameIndexRoute
  '/messages/$conversationId': typeof UserMessagesConversationIdIndexRoute
  '/settings/password': typeof UserSettingsPasswordIndexRoute
  '/settings/profile': typeof UserSettingsProfileIndexRoute
  '/coach/business': typeof CoachBackendBusinessIndexRoute
  '/coach/edit-profile': typeof CoachBackendEditProfileIndexRoute
  '/coach/invoices': typeof CoachBackendInvoicesIndexRoute
  '/coach/membership-plans': typeof CoachBackendMembershipPlansIndexRoute
  '/coach/messages': typeof CoachBackendMessagesIndexRoute
  '/coach/stripe-connect': typeof CoachBackendStripeConnectIndexRoute
  '/summit/$summitId/session/$sessionId': typeof PublicSummitSummitIdSessionSessionIdRoute
  '/$username/offer/$offerId': typeof UsernameProfileOfferOfferIdIndexRoute
  '/$username/resources/$resourceId': typeof UsernameProfileResourcesResourceIdIndexRoute
  '/coaches/category/$categorySlug': typeof PublicCoachesCategoryCategorySlugIndexRoute
  '/coaches/cco/$slug': typeof PublicCoachesCcoSlugIndexRoute
  '/coaches/city/$slug': typeof PublicCoachesCitySlugIndexRoute
  '/coaches/subcategory/$subcategorySlug': typeof PublicCoachesSubcategorySubcategorySlugIndexRoute
  '/discovery/$username/book': typeof PublicDiscoveryUsernameBookIndexRoute
  '/discovery/$username/offer': typeof PublicDiscoveryUsernameOfferIndexRoute
  '/discovery/$username/resources': typeof PublicDiscoveryUsernameResourcesIndexRoute
  '/discovery/steps/1': typeof PublicDiscoverySteps1IndexRoute
  '/discovery/steps/10': typeof PublicDiscoverySteps10IndexRoute
  '/discovery/steps/2': typeof PublicDiscoverySteps2IndexRoute
  '/discovery/steps/3': typeof PublicDiscoverySteps3IndexRoute
  '/discovery/steps/4': typeof PublicDiscoverySteps4IndexRoute
  '/discovery/steps/5': typeof PublicDiscoverySteps5IndexRoute
  '/discovery/steps/6': typeof PublicDiscoverySteps6IndexRoute
  '/discovery/steps/7': typeof PublicDiscoverySteps7IndexRoute
  '/discovery/steps/8': typeof PublicDiscoverySteps8IndexRoute
  '/discovery/steps/9': typeof PublicDiscoverySteps9IndexRoute
  '/discovery/steps/processing': typeof PublicDiscoveryStepsProcessingIndexRoute
  '/coach/edit-profile/client-flow': typeof CoachBackendEditProfileClientFlowIndexRoute
  '/coach/edit-profile/details': typeof CoachBackendEditProfileDetailsIndexRoute
  '/coach/edit-profile/offer': typeof CoachBackendEditProfileOfferIndexRoute
  '/coach/edit-profile/offers': typeof CoachBackendEditProfileOffersIndexRoute
  '/coach/edit-profile/personal-info': typeof CoachBackendEditProfilePersonalInfoIndexRoute
  '/coach/edit-profile/profile': typeof CoachBackendEditProfileProfileIndexRoute
  '/coach/edit-profile/qualifications': typeof CoachBackendEditProfileQualificationsIndexRoute
  '/coach/edit-profile/resources': typeof CoachBackendEditProfileResourcesIndexRoute
  '/coach/messages/$conversationId': typeof CoachBackendMessagesConversationIdIndexRoute
  '/coach/edit-profile/offers/$offerId': typeof CoachBackendEditProfileOffersOfferIdIndexRoute
  '/coach/edit-profile/resources/$resourceId': typeof CoachBackendEditProfileResourcesResourceIdIndexRoute
  '/coaches/city/$slug/category/$categorySlug': typeof PublicCoachesCitySlugCategoryCategorySlugIndexRoute
  '/coaches/city/$slug/subcategory/$subcategorySlug': typeof PublicCoachesCitySlugSubcategorySubcategorySlugIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$username': typeof UsernameRouteWithChildren
  '/404': typeof R404Route
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_user': typeof UserRouteWithChildren
  '/blog': typeof BlogRouteWithChildren
  '/$username/_profile': typeof UsernameProfileRouteWithChildren
  '/$username/resources': typeof UsernameResourcesRoute
  '/_user/dashboard': typeof UserDashboardRoute
  '/coach': typeof CoachRouteWithChildren
  '/coach/_backend': typeof CoachBackendRouteWithChildren
  '/coach/unauthenticated': typeof CoachUnauthenticatedRoute
  '/blog/': typeof BlogIndexRoute
  '/lc-payment/': typeof LcPaymentIndexRoute
  '/summit/': typeof SummitIndexRoute
  '/$username/_profile/resources': typeof UsernameProfileResourcesRouteWithChildren
  '/_public/discovery/$username': typeof PublicDiscoveryUsernameRouteWithChildren
  '/_public/discovery/steps': typeof PublicDiscoveryStepsRouteWithChildren
  '/_user/settings/profile': typeof UserSettingsProfileRouteWithChildren
  '/_user/summit/agenda': typeof UserSummitAgendaRoute
  '/coach/_backend/edit-profile': typeof CoachBackendEditProfileRouteWithChildren
  '/coach/_backend/messages': typeof CoachBackendMessagesRouteWithChildren
  '/$username/_profile/': typeof UsernameProfileIndexRoute
  '/$username/book/': typeof UsernameBookIndexRoute
  '/$username/contact/': typeof UsernameContactIndexRoute
  '/_auth/accept-token/': typeof AuthAcceptTokenIndexRoute
  '/_auth/forgot-password/': typeof AuthForgotPasswordIndexRoute
  '/_auth/signin/': typeof AuthSigninIndexRoute
  '/_auth/signup/': typeof AuthSignupIndexRoute
  '/_public/ccos/': typeof PublicCcosIndexRoute
  '/_public/discovery/': typeof PublicDiscoveryIndexRoute
  '/_user/coach-discovery/': typeof UserCoachDiscoveryIndexRoute
  '/_user/messages/': typeof UserMessagesIndexRoute
  '/_user/settings/': typeof UserSettingsIndexRoute
  '/admin/coaches/': typeof AdminCoachesIndexRoute
  '/admin/finder/': typeof AdminFinderIndexRoute
  '/admin/integrations/': typeof AdminIntegrationsIndexRoute
  '/admin/stripe/': typeof AdminStripeIndexRoute
  '/blog/$slug/': typeof BlogSlugIndexRoute
  '/blog/members/': typeof BlogMembersIndexRoute
  '/embed/coach-levels/': typeof EmbedCoachLevelsIndexRoute
  '/embed/new-coaches-30d/': typeof EmbedNewCoaches30dIndexRoute
  '/embed/number-of-coaches/': typeof EmbedNumberOfCoachesIndexRoute
  '/embed/number-of-users/': typeof EmbedNumberOfUsersIndexRoute
  '/_user/settings/profile/coaching-preferences': typeof UserSettingsProfileCoachingPreferencesRoute
  '/coach/_backend/edit-profile/offers': typeof CoachBackendEditProfileOffersRouteWithChildren
  '/$username/_profile/offer/': typeof UsernameProfileOfferIndexRoute
  '/$username/_profile/resources/': typeof UsernameProfileResourcesIndexRoute
  '/_public/coaches/category/': typeof PublicCoachesCategoryIndexRoute
  '/_public/coaches/cco/': typeof PublicCoachesCcoIndexRoute
  '/_public/coaches/city/': typeof PublicCoachesCityIndexRoute
  '/_public/coaches/founding/': typeof PublicCoachesFoundingIndexRoute
  '/_public/coaches/subcategory/': typeof PublicCoachesSubcategoryIndexRoute
  '/_public/discovery/$username/': typeof PublicDiscoveryUsernameIndexRoute
  '/_public/discovery/steps/': typeof PublicDiscoveryStepsIndexRoute
  '/_public/page/$name/': typeof PublicPageNameIndexRoute
  '/_user/messages/$conversationId/': typeof UserMessagesConversationIdIndexRoute
  '/_user/settings/password/': typeof UserSettingsPasswordIndexRoute
  '/_user/settings/profile/': typeof UserSettingsProfileIndexRoute
  '/coach/_backend/business/': typeof CoachBackendBusinessIndexRoute
  '/coach/_backend/edit-profile/': typeof CoachBackendEditProfileIndexRoute
  '/coach/_backend/invoices/': typeof CoachBackendInvoicesIndexRoute
  '/coach/_backend/membership-plans/': typeof CoachBackendMembershipPlansIndexRoute
  '/coach/_backend/messages/': typeof CoachBackendMessagesIndexRoute
  '/coach/_backend/stripe-connect/': typeof CoachBackendStripeConnectIndexRoute
  '/_public/summit/$summitId/session/$sessionId': typeof PublicSummitSummitIdSessionSessionIdRoute
  '/$username/_profile/offer/$offerId/': typeof UsernameProfileOfferOfferIdIndexRoute
  '/$username/_profile/resources/$resourceId/': typeof UsernameProfileResourcesResourceIdIndexRoute
  '/_public/coaches/category/$categorySlug/': typeof PublicCoachesCategoryCategorySlugIndexRoute
  '/_public/coaches/cco/$slug/': typeof PublicCoachesCcoSlugIndexRoute
  '/_public/coaches/city/$slug/': typeof PublicCoachesCitySlugIndexRoute
  '/_public/coaches/subcategory/$subcategorySlug/': typeof PublicCoachesSubcategorySubcategorySlugIndexRoute
  '/_public/discovery/$username/book/': typeof PublicDiscoveryUsernameBookIndexRoute
  '/_public/discovery/$username/offer/': typeof PublicDiscoveryUsernameOfferIndexRoute
  '/_public/discovery/$username/resources/': typeof PublicDiscoveryUsernameResourcesIndexRoute
  '/_public/discovery/steps/1/': typeof PublicDiscoverySteps1IndexRoute
  '/_public/discovery/steps/10/': typeof PublicDiscoverySteps10IndexRoute
  '/_public/discovery/steps/2/': typeof PublicDiscoverySteps2IndexRoute
  '/_public/discovery/steps/3/': typeof PublicDiscoverySteps3IndexRoute
  '/_public/discovery/steps/4/': typeof PublicDiscoverySteps4IndexRoute
  '/_public/discovery/steps/5/': typeof PublicDiscoverySteps5IndexRoute
  '/_public/discovery/steps/6/': typeof PublicDiscoverySteps6IndexRoute
  '/_public/discovery/steps/7/': typeof PublicDiscoverySteps7IndexRoute
  '/_public/discovery/steps/8/': typeof PublicDiscoverySteps8IndexRoute
  '/_public/discovery/steps/9/': typeof PublicDiscoverySteps9IndexRoute
  '/_public/discovery/steps/processing/': typeof PublicDiscoveryStepsProcessingIndexRoute
  '/coach/_backend/edit-profile/client-flow/': typeof CoachBackendEditProfileClientFlowIndexRoute
  '/coach/_backend/edit-profile/details/': typeof CoachBackendEditProfileDetailsIndexRoute
  '/coach/_backend/edit-profile/offer/': typeof CoachBackendEditProfileOfferIndexRoute
  '/coach/_backend/edit-profile/offers/': typeof CoachBackendEditProfileOffersIndexRoute
  '/coach/_backend/edit-profile/personal-info/': typeof CoachBackendEditProfilePersonalInfoIndexRoute
  '/coach/_backend/edit-profile/profile/': typeof CoachBackendEditProfileProfileIndexRoute
  '/coach/_backend/edit-profile/qualifications/': typeof CoachBackendEditProfileQualificationsIndexRoute
  '/coach/_backend/edit-profile/resources/': typeof CoachBackendEditProfileResourcesIndexRoute
  '/coach/_backend/messages/$conversationId/': typeof CoachBackendMessagesConversationIdIndexRoute
  '/coach/_backend/edit-profile/offers/$offerId/': typeof CoachBackendEditProfileOffersOfferIdIndexRoute
  '/coach/_backend/edit-profile/resources/$resourceId/': typeof CoachBackendEditProfileResourcesResourceIdIndexRoute
  '/_public/coaches/city/$slug/category/$categorySlug/': typeof PublicCoachesCitySlugCategoryCategorySlugIndexRoute
  '/_public/coaches/city/$slug/subcategory/$subcategorySlug/': typeof PublicCoachesCitySlugSubcategorySubcategorySlugIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$username'
    | '/404'
    | '/blog'
    | '/$username/resources'
    | '/dashboard'
    | '/coach'
    | '/coach/unauthenticated'
    | '/blog/'
    | '/lc-payment'
    | '/summit'
    | '/discovery/$username'
    | '/discovery/steps'
    | '/settings/profile'
    | '/summit/agenda'
    | '/coach/edit-profile'
    | '/coach/messages'
    | '/$username/'
    | '/$username/book'
    | '/$username/contact'
    | '/accept-token'
    | '/forgot-password'
    | '/signin'
    | '/signup'
    | '/ccos'
    | '/discovery'
    | '/coach-discovery'
    | '/messages'
    | '/settings'
    | '/admin/coaches'
    | '/admin/finder'
    | '/admin/integrations'
    | '/admin/stripe'
    | '/blog/$slug'
    | '/blog/members'
    | '/embed/coach-levels'
    | '/embed/new-coaches-30d'
    | '/embed/number-of-coaches'
    | '/embed/number-of-users'
    | '/settings/profile/coaching-preferences'
    | '/coach/edit-profile/offers'
    | '/$username/offer'
    | '/$username/resources/'
    | '/coaches/category'
    | '/coaches/cco'
    | '/coaches/city'
    | '/coaches/founding'
    | '/coaches/subcategory'
    | '/discovery/$username/'
    | '/discovery/steps/'
    | '/page/$name'
    | '/messages/$conversationId'
    | '/settings/password'
    | '/settings/profile/'
    | '/coach/business'
    | '/coach/edit-profile/'
    | '/coach/invoices'
    | '/coach/membership-plans'
    | '/coach/messages/'
    | '/coach/stripe-connect'
    | '/summit/$summitId/session/$sessionId'
    | '/$username/offer/$offerId'
    | '/$username/resources/$resourceId'
    | '/coaches/category/$categorySlug'
    | '/coaches/cco/$slug'
    | '/coaches/city/$slug'
    | '/coaches/subcategory/$subcategorySlug'
    | '/discovery/$username/book'
    | '/discovery/$username/offer'
    | '/discovery/$username/resources'
    | '/discovery/steps/1'
    | '/discovery/steps/10'
    | '/discovery/steps/2'
    | '/discovery/steps/3'
    | '/discovery/steps/4'
    | '/discovery/steps/5'
    | '/discovery/steps/6'
    | '/discovery/steps/7'
    | '/discovery/steps/8'
    | '/discovery/steps/9'
    | '/discovery/steps/processing'
    | '/coach/edit-profile/client-flow'
    | '/coach/edit-profile/details'
    | '/coach/edit-profile/offer'
    | '/coach/edit-profile/offers/'
    | '/coach/edit-profile/personal-info'
    | '/coach/edit-profile/profile'
    | '/coach/edit-profile/qualifications'
    | '/coach/edit-profile/resources'
    | '/coach/messages/$conversationId'
    | '/coach/edit-profile/offers/$offerId'
    | '/coach/edit-profile/resources/$resourceId'
    | '/coaches/city/$slug/category/$categorySlug'
    | '/coaches/city/$slug/subcategory/$subcategorySlug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$username'
    | '/404'
    | '/$username/resources'
    | '/dashboard'
    | '/coach'
    | '/coach/unauthenticated'
    | '/blog'
    | '/lc-payment'
    | '/summit'
    | '/summit/agenda'
    | '/$username/book'
    | '/$username/contact'
    | '/accept-token'
    | '/forgot-password'
    | '/signin'
    | '/signup'
    | '/ccos'
    | '/discovery'
    | '/coach-discovery'
    | '/messages'
    | '/settings'
    | '/admin/coaches'
    | '/admin/finder'
    | '/admin/integrations'
    | '/admin/stripe'
    | '/blog/$slug'
    | '/blog/members'
    | '/embed/coach-levels'
    | '/embed/new-coaches-30d'
    | '/embed/number-of-coaches'
    | '/embed/number-of-users'
    | '/settings/profile/coaching-preferences'
    | '/$username/offer'
    | '/coaches/category'
    | '/coaches/cco'
    | '/coaches/city'
    | '/coaches/founding'
    | '/coaches/subcategory'
    | '/discovery/$username'
    | '/discovery/steps'
    | '/page/$name'
    | '/messages/$conversationId'
    | '/settings/password'
    | '/settings/profile'
    | '/coach/business'
    | '/coach/edit-profile'
    | '/coach/invoices'
    | '/coach/membership-plans'
    | '/coach/messages'
    | '/coach/stripe-connect'
    | '/summit/$summitId/session/$sessionId'
    | '/$username/offer/$offerId'
    | '/$username/resources/$resourceId'
    | '/coaches/category/$categorySlug'
    | '/coaches/cco/$slug'
    | '/coaches/city/$slug'
    | '/coaches/subcategory/$subcategorySlug'
    | '/discovery/$username/book'
    | '/discovery/$username/offer'
    | '/discovery/$username/resources'
    | '/discovery/steps/1'
    | '/discovery/steps/10'
    | '/discovery/steps/2'
    | '/discovery/steps/3'
    | '/discovery/steps/4'
    | '/discovery/steps/5'
    | '/discovery/steps/6'
    | '/discovery/steps/7'
    | '/discovery/steps/8'
    | '/discovery/steps/9'
    | '/discovery/steps/processing'
    | '/coach/edit-profile/client-flow'
    | '/coach/edit-profile/details'
    | '/coach/edit-profile/offer'
    | '/coach/edit-profile/offers'
    | '/coach/edit-profile/personal-info'
    | '/coach/edit-profile/profile'
    | '/coach/edit-profile/qualifications'
    | '/coach/edit-profile/resources'
    | '/coach/messages/$conversationId'
    | '/coach/edit-profile/offers/$offerId'
    | '/coach/edit-profile/resources/$resourceId'
    | '/coaches/city/$slug/category/$categorySlug'
    | '/coaches/city/$slug/subcategory/$subcategorySlug'
  id:
    | '__root__'
    | '/'
    | '/$username'
    | '/404'
    | '/_auth'
    | '/_public'
    | '/_user'
    | '/blog'
    | '/$username/_profile'
    | '/$username/resources'
    | '/_user/dashboard'
    | '/coach'
    | '/coach/_backend'
    | '/coach/unauthenticated'
    | '/blog/'
    | '/lc-payment/'
    | '/summit/'
    | '/$username/_profile/resources'
    | '/_public/discovery/$username'
    | '/_public/discovery/steps'
    | '/_user/settings/profile'
    | '/_user/summit/agenda'
    | '/coach/_backend/edit-profile'
    | '/coach/_backend/messages'
    | '/$username/_profile/'
    | '/$username/book/'
    | '/$username/contact/'
    | '/_auth/accept-token/'
    | '/_auth/forgot-password/'
    | '/_auth/signin/'
    | '/_auth/signup/'
    | '/_public/ccos/'
    | '/_public/discovery/'
    | '/_user/coach-discovery/'
    | '/_user/messages/'
    | '/_user/settings/'
    | '/admin/coaches/'
    | '/admin/finder/'
    | '/admin/integrations/'
    | '/admin/stripe/'
    | '/blog/$slug/'
    | '/blog/members/'
    | '/embed/coach-levels/'
    | '/embed/new-coaches-30d/'
    | '/embed/number-of-coaches/'
    | '/embed/number-of-users/'
    | '/_user/settings/profile/coaching-preferences'
    | '/coach/_backend/edit-profile/offers'
    | '/$username/_profile/offer/'
    | '/$username/_profile/resources/'
    | '/_public/coaches/category/'
    | '/_public/coaches/cco/'
    | '/_public/coaches/city/'
    | '/_public/coaches/founding/'
    | '/_public/coaches/subcategory/'
    | '/_public/discovery/$username/'
    | '/_public/discovery/steps/'
    | '/_public/page/$name/'
    | '/_user/messages/$conversationId/'
    | '/_user/settings/password/'
    | '/_user/settings/profile/'
    | '/coach/_backend/business/'
    | '/coach/_backend/edit-profile/'
    | '/coach/_backend/invoices/'
    | '/coach/_backend/membership-plans/'
    | '/coach/_backend/messages/'
    | '/coach/_backend/stripe-connect/'
    | '/_public/summit/$summitId/session/$sessionId'
    | '/$username/_profile/offer/$offerId/'
    | '/$username/_profile/resources/$resourceId/'
    | '/_public/coaches/category/$categorySlug/'
    | '/_public/coaches/cco/$slug/'
    | '/_public/coaches/city/$slug/'
    | '/_public/coaches/subcategory/$subcategorySlug/'
    | '/_public/discovery/$username/book/'
    | '/_public/discovery/$username/offer/'
    | '/_public/discovery/$username/resources/'
    | '/_public/discovery/steps/1/'
    | '/_public/discovery/steps/10/'
    | '/_public/discovery/steps/2/'
    | '/_public/discovery/steps/3/'
    | '/_public/discovery/steps/4/'
    | '/_public/discovery/steps/5/'
    | '/_public/discovery/steps/6/'
    | '/_public/discovery/steps/7/'
    | '/_public/discovery/steps/8/'
    | '/_public/discovery/steps/9/'
    | '/_public/discovery/steps/processing/'
    | '/coach/_backend/edit-profile/client-flow/'
    | '/coach/_backend/edit-profile/details/'
    | '/coach/_backend/edit-profile/offer/'
    | '/coach/_backend/edit-profile/offers/'
    | '/coach/_backend/edit-profile/personal-info/'
    | '/coach/_backend/edit-profile/profile/'
    | '/coach/_backend/edit-profile/qualifications/'
    | '/coach/_backend/edit-profile/resources/'
    | '/coach/_backend/messages/$conversationId/'
    | '/coach/_backend/edit-profile/offers/$offerId/'
    | '/coach/_backend/edit-profile/resources/$resourceId/'
    | '/_public/coaches/city/$slug/category/$categorySlug/'
    | '/_public/coaches/city/$slug/subcategory/$subcategorySlug/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  UsernameRoute: typeof UsernameRouteWithChildren
  R404Route: typeof R404Route
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  UserRoute: typeof UserRouteWithChildren
  BlogRoute: typeof BlogRouteWithChildren
  CoachRoute: typeof CoachRouteWithChildren
  LcPaymentIndexRoute: typeof LcPaymentIndexRoute
  SummitIndexRoute: typeof SummitIndexRoute
  AdminCoachesIndexRoute: typeof AdminCoachesIndexRoute
  AdminFinderIndexRoute: typeof AdminFinderIndexRoute
  AdminIntegrationsIndexRoute: typeof AdminIntegrationsIndexRoute
  AdminStripeIndexRoute: typeof AdminStripeIndexRoute
  EmbedCoachLevelsIndexRoute: typeof EmbedCoachLevelsIndexRoute
  EmbedNewCoaches30dIndexRoute: typeof EmbedNewCoaches30dIndexRoute
  EmbedNumberOfCoachesIndexRoute: typeof EmbedNumberOfCoachesIndexRoute
  EmbedNumberOfUsersIndexRoute: typeof EmbedNumberOfUsersIndexRoute
}
export interface FileServerRoutesByFullPath {
  '/sitemap-coaches-articles.xml': typeof SitemapCoachesArticlesDotxmlServerRoute
  '/sitemap-coaches.xml': typeof SitemapCoachesDotxmlServerRoute
  '/sitemap-groups.xml': typeof SitemapGroupsDotxmlServerRoute
  '/$username/social-image.svg': typeof UsernameSocialImageDotsvgServerRoute
  '/api/blog-create-article': typeof ApiBlogCreateArticleServerRoute
  '/api/backfill-expertises': typeof ApiBackfillExpertisesIndexServerRoute
  '/api/batch-reset-closest-city': typeof ApiBatchResetClosestCityIndexServerRoute
  '/api/coach-embeddings': typeof ApiCoachEmbeddingsIndexServerRoute
  '/api/coach-joined-community': typeof ApiCoachJoinedCommunityIndexServerRoute
  '/api/coach-pre-profile': typeof ApiCoachPreProfileIndexServerRoute
  '/api/generate-profile': typeof ApiGenerateProfileIndexServerRoute
  '/api/ghl-coach-status': typeof ApiGhlCoachStatusIndexServerRoute
  '/api/ghl-contract-signed': typeof ApiGhlContractSignedIndexServerRoute
  '/api/ghl-create-account': typeof ApiGhlCreateAccountIndexServerRoute
  '/api/ghl-delete-pre-profile': typeof ApiGhlDeletePreProfileIndexServerRoute
  '/api/ghl-enable-saas': typeof ApiGhlEnableSaasIndexServerRoute
  '/api/ghl-mailerlite-unsubscribe': typeof ApiGhlMailerliteUnsubscribeIndexServerRoute
  '/api/ghl-permanently-delete-profile': typeof ApiGhlPermanentlyDeleteProfileIndexServerRoute
  '/api/ghl-set-user-permissions': typeof ApiGhlSetUserPermissionsIndexServerRoute
  '/api/ghl-summit-registration': typeof ApiGhlSummitRegistrationIndexServerRoute
  '/api/mailerlite-webhook': typeof ApiMailerliteWebhookIndexServerRoute
  '/api/stripe-webhook-connect': typeof ApiStripeWebhookConnectIndexServerRoute
  '/api/stripe-webhook-direct': typeof ApiStripeWebhookDirectIndexServerRoute
  '/api/summit-order-bump-webhook': typeof ApiSummitOrderBumpWebhookIndexServerRoute
  '/api/summit-sync': typeof ApiSummitSyncIndexServerRoute
  '/api/summit-vip-webhook': typeof ApiSummitVipWebhookIndexServerRoute
  '/api/leadconnector/create-payment-config': typeof ApiLeadconnectorCreatePaymentConfigIndexServerRoute
  '/api/leadconnector/init': typeof ApiLeadconnectorInitIndexServerRoute
  '/api/leadconnector/oauth': typeof ApiLeadconnectorOauthIndexServerRoute
  '/api/leadconnector/query': typeof ApiLeadconnectorQueryIndexServerRoute
  '/api/leadconnector/webhook': typeof ApiLeadconnectorWebhookIndexServerRoute
  '/api/proxy/$key': typeof ApiProxyKeyIndexServerRoute
  '/summit/$summitId/session/$sessionId/social-image.svg': typeof PublicSummitSummitIdSessionSessionIdSocialImageDotsvgServerRoute
}
export interface FileServerRoutesByTo {
  '/sitemap-coaches-articles.xml': typeof SitemapCoachesArticlesDotxmlServerRoute
  '/sitemap-coaches.xml': typeof SitemapCoachesDotxmlServerRoute
  '/sitemap-groups.xml': typeof SitemapGroupsDotxmlServerRoute
  '/$username/social-image.svg': typeof UsernameSocialImageDotsvgServerRoute
  '/api/blog-create-article': typeof ApiBlogCreateArticleServerRoute
  '/api/backfill-expertises': typeof ApiBackfillExpertisesIndexServerRoute
  '/api/batch-reset-closest-city': typeof ApiBatchResetClosestCityIndexServerRoute
  '/api/coach-embeddings': typeof ApiCoachEmbeddingsIndexServerRoute
  '/api/coach-joined-community': typeof ApiCoachJoinedCommunityIndexServerRoute
  '/api/coach-pre-profile': typeof ApiCoachPreProfileIndexServerRoute
  '/api/generate-profile': typeof ApiGenerateProfileIndexServerRoute
  '/api/ghl-coach-status': typeof ApiGhlCoachStatusIndexServerRoute
  '/api/ghl-contract-signed': typeof ApiGhlContractSignedIndexServerRoute
  '/api/ghl-create-account': typeof ApiGhlCreateAccountIndexServerRoute
  '/api/ghl-delete-pre-profile': typeof ApiGhlDeletePreProfileIndexServerRoute
  '/api/ghl-enable-saas': typeof ApiGhlEnableSaasIndexServerRoute
  '/api/ghl-mailerlite-unsubscribe': typeof ApiGhlMailerliteUnsubscribeIndexServerRoute
  '/api/ghl-permanently-delete-profile': typeof ApiGhlPermanentlyDeleteProfileIndexServerRoute
  '/api/ghl-set-user-permissions': typeof ApiGhlSetUserPermissionsIndexServerRoute
  '/api/ghl-summit-registration': typeof ApiGhlSummitRegistrationIndexServerRoute
  '/api/mailerlite-webhook': typeof ApiMailerliteWebhookIndexServerRoute
  '/api/stripe-webhook-connect': typeof ApiStripeWebhookConnectIndexServerRoute
  '/api/stripe-webhook-direct': typeof ApiStripeWebhookDirectIndexServerRoute
  '/api/summit-order-bump-webhook': typeof ApiSummitOrderBumpWebhookIndexServerRoute
  '/api/summit-sync': typeof ApiSummitSyncIndexServerRoute
  '/api/summit-vip-webhook': typeof ApiSummitVipWebhookIndexServerRoute
  '/api/leadconnector/create-payment-config': typeof ApiLeadconnectorCreatePaymentConfigIndexServerRoute
  '/api/leadconnector/init': typeof ApiLeadconnectorInitIndexServerRoute
  '/api/leadconnector/oauth': typeof ApiLeadconnectorOauthIndexServerRoute
  '/api/leadconnector/query': typeof ApiLeadconnectorQueryIndexServerRoute
  '/api/leadconnector/webhook': typeof ApiLeadconnectorWebhookIndexServerRoute
  '/api/proxy/$key': typeof ApiProxyKeyIndexServerRoute
  '/summit/$summitId/session/$sessionId/social-image.svg': typeof PublicSummitSummitIdSessionSessionIdSocialImageDotsvgServerRoute
}
export interface FileServerRoutesById {
  __root__: typeof rootServerRouteImport
  '/sitemap-coaches-articles.xml': typeof SitemapCoachesArticlesDotxmlServerRoute
  '/sitemap-coaches.xml': typeof SitemapCoachesDotxmlServerRoute
  '/sitemap-groups.xml': typeof SitemapGroupsDotxmlServerRoute
  '/$username/social-image.svg': typeof UsernameSocialImageDotsvgServerRoute
  '/api/blog-create-article': typeof ApiBlogCreateArticleServerRoute
  '/api/backfill-expertises/': typeof ApiBackfillExpertisesIndexServerRoute
  '/api/batch-reset-closest-city/': typeof ApiBatchResetClosestCityIndexServerRoute
  '/api/coach-embeddings/': typeof ApiCoachEmbeddingsIndexServerRoute
  '/api/coach-joined-community/': typeof ApiCoachJoinedCommunityIndexServerRoute
  '/api/coach-pre-profile/': typeof ApiCoachPreProfileIndexServerRoute
  '/api/generate-profile/': typeof ApiGenerateProfileIndexServerRoute
  '/api/ghl-coach-status/': typeof ApiGhlCoachStatusIndexServerRoute
  '/api/ghl-contract-signed/': typeof ApiGhlContractSignedIndexServerRoute
  '/api/ghl-create-account/': typeof ApiGhlCreateAccountIndexServerRoute
  '/api/ghl-delete-pre-profile/': typeof ApiGhlDeletePreProfileIndexServerRoute
  '/api/ghl-enable-saas/': typeof ApiGhlEnableSaasIndexServerRoute
  '/api/ghl-mailerlite-unsubscribe/': typeof ApiGhlMailerliteUnsubscribeIndexServerRoute
  '/api/ghl-permanently-delete-profile/': typeof ApiGhlPermanentlyDeleteProfileIndexServerRoute
  '/api/ghl-set-user-permissions/': typeof ApiGhlSetUserPermissionsIndexServerRoute
  '/api/ghl-summit-registration/': typeof ApiGhlSummitRegistrationIndexServerRoute
  '/api/mailerlite-webhook/': typeof ApiMailerliteWebhookIndexServerRoute
  '/api/stripe-webhook-connect/': typeof ApiStripeWebhookConnectIndexServerRoute
  '/api/stripe-webhook-direct/': typeof ApiStripeWebhookDirectIndexServerRoute
  '/api/summit-order-bump-webhook/': typeof ApiSummitOrderBumpWebhookIndexServerRoute
  '/api/summit-sync/': typeof ApiSummitSyncIndexServerRoute
  '/api/summit-vip-webhook/': typeof ApiSummitVipWebhookIndexServerRoute
  '/api/leadconnector/create-payment-config/': typeof ApiLeadconnectorCreatePaymentConfigIndexServerRoute
  '/api/leadconnector/init/': typeof ApiLeadconnectorInitIndexServerRoute
  '/api/leadconnector/oauth/': typeof ApiLeadconnectorOauthIndexServerRoute
  '/api/leadconnector/query/': typeof ApiLeadconnectorQueryIndexServerRoute
  '/api/leadconnector/webhook/': typeof ApiLeadconnectorWebhookIndexServerRoute
  '/api/proxy/$key/': typeof ApiProxyKeyIndexServerRoute
  '/_public/summit/$summitId/session/$sessionId/social-image.svg': typeof PublicSummitSummitIdSessionSessionIdSocialImageDotsvgServerRoute
}
export interface FileServerRouteTypes {
  fileServerRoutesByFullPath: FileServerRoutesByFullPath
  fullPaths:
    | '/sitemap-coaches-articles.xml'
    | '/sitemap-coaches.xml'
    | '/sitemap-groups.xml'
    | '/$username/social-image.svg'
    | '/api/blog-create-article'
    | '/api/backfill-expertises'
    | '/api/batch-reset-closest-city'
    | '/api/coach-embeddings'
    | '/api/coach-joined-community'
    | '/api/coach-pre-profile'
    | '/api/generate-profile'
    | '/api/ghl-coach-status'
    | '/api/ghl-contract-signed'
    | '/api/ghl-create-account'
    | '/api/ghl-delete-pre-profile'
    | '/api/ghl-enable-saas'
    | '/api/ghl-mailerlite-unsubscribe'
    | '/api/ghl-permanently-delete-profile'
    | '/api/ghl-set-user-permissions'
    | '/api/ghl-summit-registration'
    | '/api/mailerlite-webhook'
    | '/api/stripe-webhook-connect'
    | '/api/stripe-webhook-direct'
    | '/api/summit-order-bump-webhook'
    | '/api/summit-sync'
    | '/api/summit-vip-webhook'
    | '/api/leadconnector/create-payment-config'
    | '/api/leadconnector/init'
    | '/api/leadconnector/oauth'
    | '/api/leadconnector/query'
    | '/api/leadconnector/webhook'
    | '/api/proxy/$key'
    | '/summit/$summitId/session/$sessionId/social-image.svg'
  fileServerRoutesByTo: FileServerRoutesByTo
  to:
    | '/sitemap-coaches-articles.xml'
    | '/sitemap-coaches.xml'
    | '/sitemap-groups.xml'
    | '/$username/social-image.svg'
    | '/api/blog-create-article'
    | '/api/backfill-expertises'
    | '/api/batch-reset-closest-city'
    | '/api/coach-embeddings'
    | '/api/coach-joined-community'
    | '/api/coach-pre-profile'
    | '/api/generate-profile'
    | '/api/ghl-coach-status'
    | '/api/ghl-contract-signed'
    | '/api/ghl-create-account'
    | '/api/ghl-delete-pre-profile'
    | '/api/ghl-enable-saas'
    | '/api/ghl-mailerlite-unsubscribe'
    | '/api/ghl-permanently-delete-profile'
    | '/api/ghl-set-user-permissions'
    | '/api/ghl-summit-registration'
    | '/api/mailerlite-webhook'
    | '/api/stripe-webhook-connect'
    | '/api/stripe-webhook-direct'
    | '/api/summit-order-bump-webhook'
    | '/api/summit-sync'
    | '/api/summit-vip-webhook'
    | '/api/leadconnector/create-payment-config'
    | '/api/leadconnector/init'
    | '/api/leadconnector/oauth'
    | '/api/leadconnector/query'
    | '/api/leadconnector/webhook'
    | '/api/proxy/$key'
    | '/summit/$summitId/session/$sessionId/social-image.svg'
  id:
    | '__root__'
    | '/sitemap-coaches-articles.xml'
    | '/sitemap-coaches.xml'
    | '/sitemap-groups.xml'
    | '/$username/social-image.svg'
    | '/api/blog-create-article'
    | '/api/backfill-expertises/'
    | '/api/batch-reset-closest-city/'
    | '/api/coach-embeddings/'
    | '/api/coach-joined-community/'
    | '/api/coach-pre-profile/'
    | '/api/generate-profile/'
    | '/api/ghl-coach-status/'
    | '/api/ghl-contract-signed/'
    | '/api/ghl-create-account/'
    | '/api/ghl-delete-pre-profile/'
    | '/api/ghl-enable-saas/'
    | '/api/ghl-mailerlite-unsubscribe/'
    | '/api/ghl-permanently-delete-profile/'
    | '/api/ghl-set-user-permissions/'
    | '/api/ghl-summit-registration/'
    | '/api/mailerlite-webhook/'
    | '/api/stripe-webhook-connect/'
    | '/api/stripe-webhook-direct/'
    | '/api/summit-order-bump-webhook/'
    | '/api/summit-sync/'
    | '/api/summit-vip-webhook/'
    | '/api/leadconnector/create-payment-config/'
    | '/api/leadconnector/init/'
    | '/api/leadconnector/oauth/'
    | '/api/leadconnector/query/'
    | '/api/leadconnector/webhook/'
    | '/api/proxy/$key/'
    | '/_public/summit/$summitId/session/$sessionId/social-image.svg'
  fileServerRoutesById: FileServerRoutesById
}
export interface RootServerRouteChildren {
  SitemapCoachesArticlesDotxmlServerRoute: typeof SitemapCoachesArticlesDotxmlServerRoute
  SitemapCoachesDotxmlServerRoute: typeof SitemapCoachesDotxmlServerRoute
  SitemapGroupsDotxmlServerRoute: typeof SitemapGroupsDotxmlServerRoute
  UsernameSocialImageDotsvgServerRoute: typeof UsernameSocialImageDotsvgServerRoute
  ApiBlogCreateArticleServerRoute: typeof ApiBlogCreateArticleServerRoute
  ApiBackfillExpertisesIndexServerRoute: typeof ApiBackfillExpertisesIndexServerRoute
  ApiBatchResetClosestCityIndexServerRoute: typeof ApiBatchResetClosestCityIndexServerRoute
  ApiCoachEmbeddingsIndexServerRoute: typeof ApiCoachEmbeddingsIndexServerRoute
  ApiCoachJoinedCommunityIndexServerRoute: typeof ApiCoachJoinedCommunityIndexServerRoute
  ApiCoachPreProfileIndexServerRoute: typeof ApiCoachPreProfileIndexServerRoute
  ApiGenerateProfileIndexServerRoute: typeof ApiGenerateProfileIndexServerRoute
  ApiGhlCoachStatusIndexServerRoute: typeof ApiGhlCoachStatusIndexServerRoute
  ApiGhlContractSignedIndexServerRoute: typeof ApiGhlContractSignedIndexServerRoute
  ApiGhlCreateAccountIndexServerRoute: typeof ApiGhlCreateAccountIndexServerRoute
  ApiGhlDeletePreProfileIndexServerRoute: typeof ApiGhlDeletePreProfileIndexServerRoute
  ApiGhlEnableSaasIndexServerRoute: typeof ApiGhlEnableSaasIndexServerRoute
  ApiGhlMailerliteUnsubscribeIndexServerRoute: typeof ApiGhlMailerliteUnsubscribeIndexServerRoute
  ApiGhlPermanentlyDeleteProfileIndexServerRoute: typeof ApiGhlPermanentlyDeleteProfileIndexServerRoute
  ApiGhlSetUserPermissionsIndexServerRoute: typeof ApiGhlSetUserPermissionsIndexServerRoute
  ApiGhlSummitRegistrationIndexServerRoute: typeof ApiGhlSummitRegistrationIndexServerRoute
  ApiMailerliteWebhookIndexServerRoute: typeof ApiMailerliteWebhookIndexServerRoute
  ApiStripeWebhookConnectIndexServerRoute: typeof ApiStripeWebhookConnectIndexServerRoute
  ApiStripeWebhookDirectIndexServerRoute: typeof ApiStripeWebhookDirectIndexServerRoute
  ApiSummitOrderBumpWebhookIndexServerRoute: typeof ApiSummitOrderBumpWebhookIndexServerRoute
  ApiSummitSyncIndexServerRoute: typeof ApiSummitSyncIndexServerRoute
  ApiSummitVipWebhookIndexServerRoute: typeof ApiSummitVipWebhookIndexServerRoute
  ApiLeadconnectorCreatePaymentConfigIndexServerRoute: typeof ApiLeadconnectorCreatePaymentConfigIndexServerRoute
  ApiLeadconnectorInitIndexServerRoute: typeof ApiLeadconnectorInitIndexServerRoute
  ApiLeadconnectorOauthIndexServerRoute: typeof ApiLeadconnectorOauthIndexServerRoute
  ApiLeadconnectorQueryIndexServerRoute: typeof ApiLeadconnectorQueryIndexServerRoute
  ApiLeadconnectorWebhookIndexServerRoute: typeof ApiLeadconnectorWebhookIndexServerRoute
  ApiProxyKeyIndexServerRoute: typeof ApiProxyKeyIndexServerRoute
  PublicSummitSummitIdSessionSessionIdSocialImageDotsvgServerRoute: typeof PublicSummitSummitIdSessionSessionIdSocialImageDotsvgServerRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/coach': {
      id: '/coach'
      path: '/coach'
      fullPath: '/coach'
      preLoaderRoute: typeof CoachRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_user': {
      id: '/_user'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UserRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$username': {
      id: '/$username'
      path: '/$username'
      fullPath: '/$username'
      preLoaderRoute: typeof UsernameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/summit/': {
      id: '/summit/'
      path: '/summit'
      fullPath: '/summit'
      preLoaderRoute: typeof SummitIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lc-payment/': {
      id: '/lc-payment/'
      path: '/lc-payment'
      fullPath: '/lc-payment'
      preLoaderRoute: typeof LcPaymentIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/': {
      id: '/blog/'
      path: '/'
      fullPath: '/blog/'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof BlogRoute
    }
    '/coach/unauthenticated': {
      id: '/coach/unauthenticated'
      path: '/unauthenticated'
      fullPath: '/coach/unauthenticated'
      preLoaderRoute: typeof CoachUnauthenticatedRouteImport
      parentRoute: typeof CoachRoute
    }
    '/coach/_backend': {
      id: '/coach/_backend'
      path: '/coach'
      fullPath: '/coach'
      preLoaderRoute: typeof CoachBackendRouteImport
      parentRoute: typeof CoachRoute
    }
    '/_user/dashboard': {
      id: '/_user/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof UserDashboardRouteImport
      parentRoute: typeof UserRoute
    }
    '/$username/resources': {
      id: '/$username/resources'
      path: '/resources'
      fullPath: '/$username/resources'
      preLoaderRoute: typeof UsernameResourcesRouteImport
      parentRoute: typeof UsernameRoute
    }
    '/$username/_profile': {
      id: '/$username/_profile'
      path: ''
      fullPath: '/$username'
      preLoaderRoute: typeof UsernameProfileRouteImport
      parentRoute: typeof UsernameRoute
    }
    '/embed/number-of-users/': {
      id: '/embed/number-of-users/'
      path: '/embed/number-of-users'
      fullPath: '/embed/number-of-users'
      preLoaderRoute: typeof EmbedNumberOfUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embed/number-of-coaches/': {
      id: '/embed/number-of-coaches/'
      path: '/embed/number-of-coaches'
      fullPath: '/embed/number-of-coaches'
      preLoaderRoute: typeof EmbedNumberOfCoachesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embed/new-coaches-30d/': {
      id: '/embed/new-coaches-30d/'
      path: '/embed/new-coaches-30d'
      fullPath: '/embed/new-coaches-30d'
      preLoaderRoute: typeof EmbedNewCoaches30dIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embed/coach-levels/': {
      id: '/embed/coach-levels/'
      path: '/embed/coach-levels'
      fullPath: '/embed/coach-levels'
      preLoaderRoute: typeof EmbedCoachLevelsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/members/': {
      id: '/blog/members/'
      path: '/members'
      fullPath: '/blog/members'
      preLoaderRoute: typeof BlogMembersIndexRouteImport
      parentRoute: typeof BlogRoute
    }
    '/blog/$slug/': {
      id: '/blog/$slug/'
      path: '/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugIndexRouteImport
      parentRoute: typeof BlogRoute
    }
    '/admin/stripe/': {
      id: '/admin/stripe/'
      path: '/admin/stripe'
      fullPath: '/admin/stripe'
      preLoaderRoute: typeof AdminStripeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/integrations/': {
      id: '/admin/integrations/'
      path: '/admin/integrations'
      fullPath: '/admin/integrations'
      preLoaderRoute: typeof AdminIntegrationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/finder/': {
      id: '/admin/finder/'
      path: '/admin/finder'
      fullPath: '/admin/finder'
      preLoaderRoute: typeof AdminFinderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/coaches/': {
      id: '/admin/coaches/'
      path: '/admin/coaches'
      fullPath: '/admin/coaches'
      preLoaderRoute: typeof AdminCoachesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_user/settings/': {
      id: '/_user/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof UserSettingsIndexRouteImport
      parentRoute: typeof UserRoute
    }
    '/_user/messages/': {
      id: '/_user/messages/'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof UserMessagesIndexRouteImport
      parentRoute: typeof UserRoute
    }
    '/_user/coach-discovery/': {
      id: '/_user/coach-discovery/'
      path: '/coach-discovery'
      fullPath: '/coach-discovery'
      preLoaderRoute: typeof UserCoachDiscoveryIndexRouteImport
      parentRoute: typeof UserRoute
    }
    '/_public/discovery/': {
      id: '/_public/discovery/'
      path: '/discovery'
      fullPath: '/discovery'
      preLoaderRoute: typeof PublicDiscoveryIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/ccos/': {
      id: '/_public/ccos/'
      path: '/ccos'
      fullPath: '/ccos'
      preLoaderRoute: typeof PublicCcosIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/signup/': {
      id: '/_auth/signup/'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/signin/': {
      id: '/_auth/signin/'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof AuthSigninIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password/': {
      id: '/_auth/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/accept-token/': {
      id: '/_auth/accept-token/'
      path: '/accept-token'
      fullPath: '/accept-token'
      preLoaderRoute: typeof AuthAcceptTokenIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/$username/contact/': {
      id: '/$username/contact/'
      path: '/contact'
      fullPath: '/$username/contact'
      preLoaderRoute: typeof UsernameContactIndexRouteImport
      parentRoute: typeof UsernameRoute
    }
    '/$username/book/': {
      id: '/$username/book/'
      path: '/book'
      fullPath: '/$username/book'
      preLoaderRoute: typeof UsernameBookIndexRouteImport
      parentRoute: typeof UsernameRoute
    }
    '/$username/_profile/': {
      id: '/$username/_profile/'
      path: '/'
      fullPath: '/$username/'
      preLoaderRoute: typeof UsernameProfileIndexRouteImport
      parentRoute: typeof UsernameProfileRoute
    }
    '/coach/_backend/messages': {
      id: '/coach/_backend/messages'
      path: '/messages'
      fullPath: '/coach/messages'
      preLoaderRoute: typeof CoachBackendMessagesRouteImport
      parentRoute: typeof CoachBackendRoute
    }
    '/coach/_backend/edit-profile': {
      id: '/coach/_backend/edit-profile'
      path: '/edit-profile'
      fullPath: '/coach/edit-profile'
      preLoaderRoute: typeof CoachBackendEditProfileRouteImport
      parentRoute: typeof CoachBackendRoute
    }
    '/_user/summit/agenda': {
      id: '/_user/summit/agenda'
      path: '/summit/agenda'
      fullPath: '/summit/agenda'
      preLoaderRoute: typeof UserSummitAgendaRouteImport
      parentRoute: typeof UserRoute
    }
    '/_user/settings/profile': {
      id: '/_user/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof UserSettingsProfileRouteImport
      parentRoute: typeof UserRoute
    }
    '/_public/discovery/steps': {
      id: '/_public/discovery/steps'
      path: '/discovery/steps'
      fullPath: '/discovery/steps'
      preLoaderRoute: typeof PublicDiscoveryStepsRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/discovery/$username': {
      id: '/_public/discovery/$username'
      path: '/discovery/$username'
      fullPath: '/discovery/$username'
      preLoaderRoute: typeof PublicDiscoveryUsernameRouteImport
      parentRoute: typeof PublicRoute
    }
    '/$username/_profile/resources': {
      id: '/$username/_profile/resources'
      path: '/resources'
      fullPath: '/$username/resources'
      preLoaderRoute: typeof UsernameProfileResourcesRouteImport
      parentRoute: typeof UsernameProfileRoute
    }
    '/coach/_backend/stripe-connect/': {
      id: '/coach/_backend/stripe-connect/'
      path: '/stripe-connect'
      fullPath: '/coach/stripe-connect'
      preLoaderRoute: typeof CoachBackendStripeConnectIndexRouteImport
      parentRoute: typeof CoachBackendRoute
    }
    '/coach/_backend/messages/': {
      id: '/coach/_backend/messages/'
      path: '/'
      fullPath: '/coach/messages/'
      preLoaderRoute: typeof CoachBackendMessagesIndexRouteImport
      parentRoute: typeof CoachBackendMessagesRoute
    }
    '/coach/_backend/membership-plans/': {
      id: '/coach/_backend/membership-plans/'
      path: '/membership-plans'
      fullPath: '/coach/membership-plans'
      preLoaderRoute: typeof CoachBackendMembershipPlansIndexRouteImport
      parentRoute: typeof CoachBackendRoute
    }
    '/coach/_backend/invoices/': {
      id: '/coach/_backend/invoices/'
      path: '/invoices'
      fullPath: '/coach/invoices'
      preLoaderRoute: typeof CoachBackendInvoicesIndexRouteImport
      parentRoute: typeof CoachBackendRoute
    }
    '/coach/_backend/edit-profile/': {
      id: '/coach/_backend/edit-profile/'
      path: '/'
      fullPath: '/coach/edit-profile/'
      preLoaderRoute: typeof CoachBackendEditProfileIndexRouteImport
      parentRoute: typeof CoachBackendEditProfileRoute
    }
    '/coach/_backend/business/': {
      id: '/coach/_backend/business/'
      path: '/business'
      fullPath: '/coach/business'
      preLoaderRoute: typeof CoachBackendBusinessIndexRouteImport
      parentRoute: typeof CoachBackendRoute
    }
    '/_user/settings/profile/': {
      id: '/_user/settings/profile/'
      path: '/'
      fullPath: '/settings/profile/'
      preLoaderRoute: typeof UserSettingsProfileIndexRouteImport
      parentRoute: typeof UserSettingsProfileRoute
    }
    '/_user/settings/password/': {
      id: '/_user/settings/password/'
      path: '/settings/password'
      fullPath: '/settings/password'
      preLoaderRoute: typeof UserSettingsPasswordIndexRouteImport
      parentRoute: typeof UserRoute
    }
    '/_user/messages/$conversationId/': {
      id: '/_user/messages/$conversationId/'
      path: '/messages/$conversationId'
      fullPath: '/messages/$conversationId'
      preLoaderRoute: typeof UserMessagesConversationIdIndexRouteImport
      parentRoute: typeof UserRoute
    }
    '/_public/page/$name/': {
      id: '/_public/page/$name/'
      path: '/page/$name'
      fullPath: '/page/$name'
      preLoaderRoute: typeof PublicPageNameIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/discovery/steps/': {
      id: '/_public/discovery/steps/'
      path: '/'
      fullPath: '/discovery/steps/'
      preLoaderRoute: typeof PublicDiscoveryStepsIndexRouteImport
      parentRoute: typeof PublicDiscoveryStepsRoute
    }
    '/_public/discovery/$username/': {
      id: '/_public/discovery/$username/'
      path: '/'
      fullPath: '/discovery/$username/'
      preLoaderRoute: typeof PublicDiscoveryUsernameIndexRouteImport
      parentRoute: typeof PublicDiscoveryUsernameRoute
    }
    '/_public/coaches/subcategory/': {
      id: '/_public/coaches/subcategory/'
      path: '/coaches/subcategory'
      fullPath: '/coaches/subcategory'
      preLoaderRoute: typeof PublicCoachesSubcategoryIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/coaches/founding/': {
      id: '/_public/coaches/founding/'
      path: '/coaches/founding'
      fullPath: '/coaches/founding'
      preLoaderRoute: typeof PublicCoachesFoundingIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/coaches/city/': {
      id: '/_public/coaches/city/'
      path: '/coaches/city'
      fullPath: '/coaches/city'
      preLoaderRoute: typeof PublicCoachesCityIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/coaches/cco/': {
      id: '/_public/coaches/cco/'
      path: '/coaches/cco'
      fullPath: '/coaches/cco'
      preLoaderRoute: typeof PublicCoachesCcoIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/coaches/category/': {
      id: '/_public/coaches/category/'
      path: '/coaches/category'
      fullPath: '/coaches/category'
      preLoaderRoute: typeof PublicCoachesCategoryIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/$username/_profile/resources/': {
      id: '/$username/_profile/resources/'
      path: '/'
      fullPath: '/$username/resources/'
      preLoaderRoute: typeof UsernameProfileResourcesIndexRouteImport
      parentRoute: typeof UsernameProfileResourcesRoute
    }
    '/$username/_profile/offer/': {
      id: '/$username/_profile/offer/'
      path: '/offer'
      fullPath: '/$username/offer'
      preLoaderRoute: typeof UsernameProfileOfferIndexRouteImport
      parentRoute: typeof UsernameProfileRoute
    }
    '/coach/_backend/edit-profile/offers': {
      id: '/coach/_backend/edit-profile/offers'
      path: '/offers'
      fullPath: '/coach/edit-profile/offers'
      preLoaderRoute: typeof CoachBackendEditProfileOffersRouteImport
      parentRoute: typeof CoachBackendEditProfileRoute
    }
    '/_user/settings/profile/coaching-preferences': {
      id: '/_user/settings/profile/coaching-preferences'
      path: '/coaching-preferences'
      fullPath: '/settings/profile/coaching-preferences'
      preLoaderRoute: typeof UserSettingsProfileCoachingPreferencesRouteImport
      parentRoute: typeof UserSettingsProfileRoute
    }
    '/coach/_backend/messages/$conversationId/': {
      id: '/coach/_backend/messages/$conversationId/'
      path: '/$conversationId'
      fullPath: '/coach/messages/$conversationId'
      preLoaderRoute: typeof CoachBackendMessagesConversationIdIndexRouteImport
      parentRoute: typeof CoachBackendMessagesRoute
    }
    '/coach/_backend/edit-profile/resources/': {
      id: '/coach/_backend/edit-profile/resources/'
      path: '/resources'
      fullPath: '/coach/edit-profile/resources'
      preLoaderRoute: typeof CoachBackendEditProfileResourcesIndexRouteImport
      parentRoute: typeof CoachBackendEditProfileRoute
    }
    '/coach/_backend/edit-profile/qualifications/': {
      id: '/coach/_backend/edit-profile/qualifications/'
      path: '/qualifications'
      fullPath: '/coach/edit-profile/qualifications'
      preLoaderRoute: typeof CoachBackendEditProfileQualificationsIndexRouteImport
      parentRoute: typeof CoachBackendEditProfileRoute
    }
    '/coach/_backend/edit-profile/profile/': {
      id: '/coach/_backend/edit-profile/profile/'
      path: '/profile'
      fullPath: '/coach/edit-profile/profile'
      preLoaderRoute: typeof CoachBackendEditProfileProfileIndexRouteImport
      parentRoute: typeof CoachBackendEditProfileRoute
    }
    '/coach/_backend/edit-profile/personal-info/': {
      id: '/coach/_backend/edit-profile/personal-info/'
      path: '/personal-info'
      fullPath: '/coach/edit-profile/personal-info'
      preLoaderRoute: typeof CoachBackendEditProfilePersonalInfoIndexRouteImport
      parentRoute: typeof CoachBackendEditProfileRoute
    }
    '/coach/_backend/edit-profile/offers/': {
      id: '/coach/_backend/edit-profile/offers/'
      path: '/'
      fullPath: '/coach/edit-profile/offers/'
      preLoaderRoute: typeof CoachBackendEditProfileOffersIndexRouteImport
      parentRoute: typeof CoachBackendEditProfileOffersRoute
    }
    '/coach/_backend/edit-profile/offer/': {
      id: '/coach/_backend/edit-profile/offer/'
      path: '/offer'
      fullPath: '/coach/edit-profile/offer'
      preLoaderRoute: typeof CoachBackendEditProfileOfferIndexRouteImport
      parentRoute: typeof CoachBackendEditProfileRoute
    }
    '/coach/_backend/edit-profile/details/': {
      id: '/coach/_backend/edit-profile/details/'
      path: '/details'
      fullPath: '/coach/edit-profile/details'
      preLoaderRoute: typeof CoachBackendEditProfileDetailsIndexRouteImport
      parentRoute: typeof CoachBackendEditProfileRoute
    }
    '/coach/_backend/edit-profile/client-flow/': {
      id: '/coach/_backend/edit-profile/client-flow/'
      path: '/client-flow'
      fullPath: '/coach/edit-profile/client-flow'
      preLoaderRoute: typeof CoachBackendEditProfileClientFlowIndexRouteImport
      parentRoute: typeof CoachBackendEditProfileRoute
    }
    '/_public/discovery/steps/processing/': {
      id: '/_public/discovery/steps/processing/'
      path: '/processing'
      fullPath: '/discovery/steps/processing'
      preLoaderRoute: typeof PublicDiscoveryStepsProcessingIndexRouteImport
      parentRoute: typeof PublicDiscoveryStepsRoute
    }
    '/_public/discovery/steps/9/': {
      id: '/_public/discovery/steps/9/'
      path: '/9'
      fullPath: '/discovery/steps/9'
      preLoaderRoute: typeof PublicDiscoverySteps9IndexRouteImport
      parentRoute: typeof PublicDiscoveryStepsRoute
    }
    '/_public/discovery/steps/8/': {
      id: '/_public/discovery/steps/8/'
      path: '/8'
      fullPath: '/discovery/steps/8'
      preLoaderRoute: typeof PublicDiscoverySteps8IndexRouteImport
      parentRoute: typeof PublicDiscoveryStepsRoute
    }
    '/_public/discovery/steps/7/': {
      id: '/_public/discovery/steps/7/'
      path: '/7'
      fullPath: '/discovery/steps/7'
      preLoaderRoute: typeof PublicDiscoverySteps7IndexRouteImport
      parentRoute: typeof PublicDiscoveryStepsRoute
    }
    '/_public/discovery/steps/6/': {
      id: '/_public/discovery/steps/6/'
      path: '/6'
      fullPath: '/discovery/steps/6'
      preLoaderRoute: typeof PublicDiscoverySteps6IndexRouteImport
      parentRoute: typeof PublicDiscoveryStepsRoute
    }
    '/_public/discovery/steps/5/': {
      id: '/_public/discovery/steps/5/'
      path: '/5'
      fullPath: '/discovery/steps/5'
      preLoaderRoute: typeof PublicDiscoverySteps5IndexRouteImport
      parentRoute: typeof PublicDiscoveryStepsRoute
    }
    '/_public/discovery/steps/4/': {
      id: '/_public/discovery/steps/4/'
      path: '/4'
      fullPath: '/discovery/steps/4'
      preLoaderRoute: typeof PublicDiscoverySteps4IndexRouteImport
      parentRoute: typeof PublicDiscoveryStepsRoute
    }
    '/_public/discovery/steps/3/': {
      id: '/_public/discovery/steps/3/'
      path: '/3'
      fullPath: '/discovery/steps/3'
      preLoaderRoute: typeof PublicDiscoverySteps3IndexRouteImport
      parentRoute: typeof PublicDiscoveryStepsRoute
    }
    '/_public/discovery/steps/2/': {
      id: '/_public/discovery/steps/2/'
      path: '/2'
      fullPath: '/discovery/steps/2'
      preLoaderRoute: typeof PublicDiscoverySteps2IndexRouteImport
      parentRoute: typeof PublicDiscoveryStepsRoute
    }
    '/_public/discovery/steps/10/': {
      id: '/_public/discovery/steps/10/'
      path: '/10'
      fullPath: '/discovery/steps/10'
      preLoaderRoute: typeof PublicDiscoverySteps10IndexRouteImport
      parentRoute: typeof PublicDiscoveryStepsRoute
    }
    '/_public/discovery/steps/1/': {
      id: '/_public/discovery/steps/1/'
      path: '/1'
      fullPath: '/discovery/steps/1'
      preLoaderRoute: typeof PublicDiscoverySteps1IndexRouteImport
      parentRoute: typeof PublicDiscoveryStepsRoute
    }
    '/_public/discovery/$username/resources/': {
      id: '/_public/discovery/$username/resources/'
      path: '/resources'
      fullPath: '/discovery/$username/resources'
      preLoaderRoute: typeof PublicDiscoveryUsernameResourcesIndexRouteImport
      parentRoute: typeof PublicDiscoveryUsernameRoute
    }
    '/_public/discovery/$username/offer/': {
      id: '/_public/discovery/$username/offer/'
      path: '/offer'
      fullPath: '/discovery/$username/offer'
      preLoaderRoute: typeof PublicDiscoveryUsernameOfferIndexRouteImport
      parentRoute: typeof PublicDiscoveryUsernameRoute
    }
    '/_public/discovery/$username/book/': {
      id: '/_public/discovery/$username/book/'
      path: '/book'
      fullPath: '/discovery/$username/book'
      preLoaderRoute: typeof PublicDiscoveryUsernameBookIndexRouteImport
      parentRoute: typeof PublicDiscoveryUsernameRoute
    }
    '/_public/coaches/subcategory/$subcategorySlug/': {
      id: '/_public/coaches/subcategory/$subcategorySlug/'
      path: '/coaches/subcategory/$subcategorySlug'
      fullPath: '/coaches/subcategory/$subcategorySlug'
      preLoaderRoute: typeof PublicCoachesSubcategorySubcategorySlugIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/coaches/city/$slug/': {
      id: '/_public/coaches/city/$slug/'
      path: '/coaches/city/$slug'
      fullPath: '/coaches/city/$slug'
      preLoaderRoute: typeof PublicCoachesCitySlugIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/coaches/cco/$slug/': {
      id: '/_public/coaches/cco/$slug/'
      path: '/coaches/cco/$slug'
      fullPath: '/coaches/cco/$slug'
      preLoaderRoute: typeof PublicCoachesCcoSlugIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/coaches/category/$categorySlug/': {
      id: '/_public/coaches/category/$categorySlug/'
      path: '/coaches/category/$categorySlug'
      fullPath: '/coaches/category/$categorySlug'
      preLoaderRoute: typeof PublicCoachesCategoryCategorySlugIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/$username/_profile/resources/$resourceId/': {
      id: '/$username/_profile/resources/$resourceId/'
      path: '/$resourceId'
      fullPath: '/$username/resources/$resourceId'
      preLoaderRoute: typeof UsernameProfileResourcesResourceIdIndexRouteImport
      parentRoute: typeof UsernameProfileResourcesRoute
    }
    '/$username/_profile/offer/$offerId/': {
      id: '/$username/_profile/offer/$offerId/'
      path: '/offer/$offerId'
      fullPath: '/$username/offer/$offerId'
      preLoaderRoute: typeof UsernameProfileOfferOfferIdIndexRouteImport
      parentRoute: typeof UsernameProfileRoute
    }
    '/_public/summit/$summitId/session/$sessionId': {
      id: '/_public/summit/$summitId/session/$sessionId'
      path: '/summit/$summitId/session/$sessionId'
      fullPath: '/summit/$summitId/session/$sessionId'
      preLoaderRoute: typeof PublicSummitSummitIdSessionSessionIdRouteImport
      parentRoute: typeof PublicRoute
    }
    '/coach/_backend/edit-profile/resources/$resourceId/': {
      id: '/coach/_backend/edit-profile/resources/$resourceId/'
      path: '/resources/$resourceId'
      fullPath: '/coach/edit-profile/resources/$resourceId'
      preLoaderRoute: typeof CoachBackendEditProfileResourcesResourceIdIndexRouteImport
      parentRoute: typeof CoachBackendEditProfileRoute
    }
    '/coach/_backend/edit-profile/offers/$offerId/': {
      id: '/coach/_backend/edit-profile/offers/$offerId/'
      path: '/$offerId'
      fullPath: '/coach/edit-profile/offers/$offerId'
      preLoaderRoute: typeof CoachBackendEditProfileOffersOfferIdIndexRouteImport
      parentRoute: typeof CoachBackendEditProfileOffersRoute
    }
    '/_public/coaches/city/$slug/subcategory/$subcategorySlug/': {
      id: '/_public/coaches/city/$slug/subcategory/$subcategorySlug/'
      path: '/coaches/city/$slug/subcategory/$subcategorySlug'
      fullPath: '/coaches/city/$slug/subcategory/$subcategorySlug'
      preLoaderRoute: typeof PublicCoachesCitySlugSubcategorySubcategorySlugIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/coaches/city/$slug/category/$categorySlug/': {
      id: '/_public/coaches/city/$slug/category/$categorySlug/'
      path: '/coaches/city/$slug/category/$categorySlug'
      fullPath: '/coaches/city/$slug/category/$categorySlug'
      preLoaderRoute: typeof PublicCoachesCitySlugCategoryCategorySlugIndexRouteImport
      parentRoute: typeof PublicRoute
    }
  }
}
declare module '@tanstack/react-start/server' {
  interface ServerFileRoutesByPath {
    '/sitemap-groups.xml': {
      id: '/sitemap-groups.xml'
      path: '/sitemap-groups.xml'
      fullPath: '/sitemap-groups.xml'
      preLoaderRoute: typeof SitemapGroupsDotxmlServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/sitemap-coaches.xml': {
      id: '/sitemap-coaches.xml'
      path: '/sitemap-coaches.xml'
      fullPath: '/sitemap-coaches.xml'
      preLoaderRoute: typeof SitemapCoachesDotxmlServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/sitemap-coaches-articles.xml': {
      id: '/sitemap-coaches-articles.xml'
      path: '/sitemap-coaches-articles.xml'
      fullPath: '/sitemap-coaches-articles.xml'
      preLoaderRoute: typeof SitemapCoachesArticlesDotxmlServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/blog-create-article': {
      id: '/api/blog-create-article'
      path: '/api/blog-create-article'
      fullPath: '/api/blog-create-article'
      preLoaderRoute: typeof ApiBlogCreateArticleServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/$username/social-image.svg': {
      id: '/$username/social-image.svg'
      path: '/$username/social-image.svg'
      fullPath: '/$username/social-image.svg'
      preLoaderRoute: typeof UsernameSocialImageDotsvgServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/summit-vip-webhook/': {
      id: '/api/summit-vip-webhook/'
      path: '/api/summit-vip-webhook'
      fullPath: '/api/summit-vip-webhook'
      preLoaderRoute: typeof ApiSummitVipWebhookIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/summit-sync/': {
      id: '/api/summit-sync/'
      path: '/api/summit-sync'
      fullPath: '/api/summit-sync'
      preLoaderRoute: typeof ApiSummitSyncIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/summit-order-bump-webhook/': {
      id: '/api/summit-order-bump-webhook/'
      path: '/api/summit-order-bump-webhook'
      fullPath: '/api/summit-order-bump-webhook'
      preLoaderRoute: typeof ApiSummitOrderBumpWebhookIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/stripe-webhook-direct/': {
      id: '/api/stripe-webhook-direct/'
      path: '/api/stripe-webhook-direct'
      fullPath: '/api/stripe-webhook-direct'
      preLoaderRoute: typeof ApiStripeWebhookDirectIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/stripe-webhook-connect/': {
      id: '/api/stripe-webhook-connect/'
      path: '/api/stripe-webhook-connect'
      fullPath: '/api/stripe-webhook-connect'
      preLoaderRoute: typeof ApiStripeWebhookConnectIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/mailerlite-webhook/': {
      id: '/api/mailerlite-webhook/'
      path: '/api/mailerlite-webhook'
      fullPath: '/api/mailerlite-webhook'
      preLoaderRoute: typeof ApiMailerliteWebhookIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/ghl-summit-registration/': {
      id: '/api/ghl-summit-registration/'
      path: '/api/ghl-summit-registration'
      fullPath: '/api/ghl-summit-registration'
      preLoaderRoute: typeof ApiGhlSummitRegistrationIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/ghl-set-user-permissions/': {
      id: '/api/ghl-set-user-permissions/'
      path: '/api/ghl-set-user-permissions'
      fullPath: '/api/ghl-set-user-permissions'
      preLoaderRoute: typeof ApiGhlSetUserPermissionsIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/ghl-permanently-delete-profile/': {
      id: '/api/ghl-permanently-delete-profile/'
      path: '/api/ghl-permanently-delete-profile'
      fullPath: '/api/ghl-permanently-delete-profile'
      preLoaderRoute: typeof ApiGhlPermanentlyDeleteProfileIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/ghl-mailerlite-unsubscribe/': {
      id: '/api/ghl-mailerlite-unsubscribe/'
      path: '/api/ghl-mailerlite-unsubscribe'
      fullPath: '/api/ghl-mailerlite-unsubscribe'
      preLoaderRoute: typeof ApiGhlMailerliteUnsubscribeIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/ghl-enable-saas/': {
      id: '/api/ghl-enable-saas/'
      path: '/api/ghl-enable-saas'
      fullPath: '/api/ghl-enable-saas'
      preLoaderRoute: typeof ApiGhlEnableSaasIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/ghl-delete-pre-profile/': {
      id: '/api/ghl-delete-pre-profile/'
      path: '/api/ghl-delete-pre-profile'
      fullPath: '/api/ghl-delete-pre-profile'
      preLoaderRoute: typeof ApiGhlDeletePreProfileIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/ghl-create-account/': {
      id: '/api/ghl-create-account/'
      path: '/api/ghl-create-account'
      fullPath: '/api/ghl-create-account'
      preLoaderRoute: typeof ApiGhlCreateAccountIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/ghl-contract-signed/': {
      id: '/api/ghl-contract-signed/'
      path: '/api/ghl-contract-signed'
      fullPath: '/api/ghl-contract-signed'
      preLoaderRoute: typeof ApiGhlContractSignedIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/ghl-coach-status/': {
      id: '/api/ghl-coach-status/'
      path: '/api/ghl-coach-status'
      fullPath: '/api/ghl-coach-status'
      preLoaderRoute: typeof ApiGhlCoachStatusIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/generate-profile/': {
      id: '/api/generate-profile/'
      path: '/api/generate-profile'
      fullPath: '/api/generate-profile'
      preLoaderRoute: typeof ApiGenerateProfileIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/coach-pre-profile/': {
      id: '/api/coach-pre-profile/'
      path: '/api/coach-pre-profile'
      fullPath: '/api/coach-pre-profile'
      preLoaderRoute: typeof ApiCoachPreProfileIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/coach-joined-community/': {
      id: '/api/coach-joined-community/'
      path: '/api/coach-joined-community'
      fullPath: '/api/coach-joined-community'
      preLoaderRoute: typeof ApiCoachJoinedCommunityIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/coach-embeddings/': {
      id: '/api/coach-embeddings/'
      path: '/api/coach-embeddings'
      fullPath: '/api/coach-embeddings'
      preLoaderRoute: typeof ApiCoachEmbeddingsIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/batch-reset-closest-city/': {
      id: '/api/batch-reset-closest-city/'
      path: '/api/batch-reset-closest-city'
      fullPath: '/api/batch-reset-closest-city'
      preLoaderRoute: typeof ApiBatchResetClosestCityIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/backfill-expertises/': {
      id: '/api/backfill-expertises/'
      path: '/api/backfill-expertises'
      fullPath: '/api/backfill-expertises'
      preLoaderRoute: typeof ApiBackfillExpertisesIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/proxy/$key/': {
      id: '/api/proxy/$key/'
      path: '/api/proxy/$key'
      fullPath: '/api/proxy/$key'
      preLoaderRoute: typeof ApiProxyKeyIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/leadconnector/webhook/': {
      id: '/api/leadconnector/webhook/'
      path: '/api/leadconnector/webhook'
      fullPath: '/api/leadconnector/webhook'
      preLoaderRoute: typeof ApiLeadconnectorWebhookIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/leadconnector/query/': {
      id: '/api/leadconnector/query/'
      path: '/api/leadconnector/query'
      fullPath: '/api/leadconnector/query'
      preLoaderRoute: typeof ApiLeadconnectorQueryIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/leadconnector/oauth/': {
      id: '/api/leadconnector/oauth/'
      path: '/api/leadconnector/oauth'
      fullPath: '/api/leadconnector/oauth'
      preLoaderRoute: typeof ApiLeadconnectorOauthIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/leadconnector/init/': {
      id: '/api/leadconnector/init/'
      path: '/api/leadconnector/init'
      fullPath: '/api/leadconnector/init'
      preLoaderRoute: typeof ApiLeadconnectorInitIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/api/leadconnector/create-payment-config/': {
      id: '/api/leadconnector/create-payment-config/'
      path: '/api/leadconnector/create-payment-config'
      fullPath: '/api/leadconnector/create-payment-config'
      preLoaderRoute: typeof ApiLeadconnectorCreatePaymentConfigIndexServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
    '/_public/summit/$summitId/session/$sessionId/social-image.svg': {
      id: '/_public/summit/$summitId/session/$sessionId/social-image.svg'
      path: '/summit/$summitId/session/$sessionId/social-image.svg'
      fullPath: '/summit/$summitId/session/$sessionId/social-image.svg'
      preLoaderRoute: typeof PublicSummitSummitIdSessionSessionIdSocialImageDotsvgServerRouteImport
      parentRoute: typeof rootServerRouteImport
    }
  }
}

interface UsernameProfileResourcesRouteChildren {
  UsernameProfileResourcesIndexRoute: typeof UsernameProfileResourcesIndexRoute
  UsernameProfileResourcesResourceIdIndexRoute: typeof UsernameProfileResourcesResourceIdIndexRoute
}

const UsernameProfileResourcesRouteChildren: UsernameProfileResourcesRouteChildren =
  {
    UsernameProfileResourcesIndexRoute: UsernameProfileResourcesIndexRoute,
    UsernameProfileResourcesResourceIdIndexRoute:
      UsernameProfileResourcesResourceIdIndexRoute,
  }

const UsernameProfileResourcesRouteWithChildren =
  UsernameProfileResourcesRoute._addFileChildren(
    UsernameProfileResourcesRouteChildren,
  )

interface UsernameProfileRouteChildren {
  UsernameProfileResourcesRoute: typeof UsernameProfileResourcesRouteWithChildren
  UsernameProfileIndexRoute: typeof UsernameProfileIndexRoute
  UsernameProfileOfferIndexRoute: typeof UsernameProfileOfferIndexRoute
  UsernameProfileOfferOfferIdIndexRoute: typeof UsernameProfileOfferOfferIdIndexRoute
}

const UsernameProfileRouteChildren: UsernameProfileRouteChildren = {
  UsernameProfileResourcesRoute: UsernameProfileResourcesRouteWithChildren,
  UsernameProfileIndexRoute: UsernameProfileIndexRoute,
  UsernameProfileOfferIndexRoute: UsernameProfileOfferIndexRoute,
  UsernameProfileOfferOfferIdIndexRoute: UsernameProfileOfferOfferIdIndexRoute,
}

const UsernameProfileRouteWithChildren = UsernameProfileRoute._addFileChildren(
  UsernameProfileRouteChildren,
)

interface UsernameRouteChildren {
  UsernameProfileRoute: typeof UsernameProfileRouteWithChildren
  UsernameResourcesRoute: typeof UsernameResourcesRoute
  UsernameBookIndexRoute: typeof UsernameBookIndexRoute
  UsernameContactIndexRoute: typeof UsernameContactIndexRoute
}

const UsernameRouteChildren: UsernameRouteChildren = {
  UsernameProfileRoute: UsernameProfileRouteWithChildren,
  UsernameResourcesRoute: UsernameResourcesRoute,
  UsernameBookIndexRoute: UsernameBookIndexRoute,
  UsernameContactIndexRoute: UsernameContactIndexRoute,
}

const UsernameRouteWithChildren = UsernameRoute._addFileChildren(
  UsernameRouteChildren,
)

interface AuthRouteChildren {
  AuthAcceptTokenIndexRoute: typeof AuthAcceptTokenIndexRoute
  AuthForgotPasswordIndexRoute: typeof AuthForgotPasswordIndexRoute
  AuthSigninIndexRoute: typeof AuthSigninIndexRoute
  AuthSignupIndexRoute: typeof AuthSignupIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAcceptTokenIndexRoute: AuthAcceptTokenIndexRoute,
  AuthForgotPasswordIndexRoute: AuthForgotPasswordIndexRoute,
  AuthSigninIndexRoute: AuthSigninIndexRoute,
  AuthSignupIndexRoute: AuthSignupIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicDiscoveryUsernameRouteChildren {
  PublicDiscoveryUsernameIndexRoute: typeof PublicDiscoveryUsernameIndexRoute
  PublicDiscoveryUsernameBookIndexRoute: typeof PublicDiscoveryUsernameBookIndexRoute
  PublicDiscoveryUsernameOfferIndexRoute: typeof PublicDiscoveryUsernameOfferIndexRoute
  PublicDiscoveryUsernameResourcesIndexRoute: typeof PublicDiscoveryUsernameResourcesIndexRoute
}

const PublicDiscoveryUsernameRouteChildren: PublicDiscoveryUsernameRouteChildren =
  {
    PublicDiscoveryUsernameIndexRoute: PublicDiscoveryUsernameIndexRoute,
    PublicDiscoveryUsernameBookIndexRoute:
      PublicDiscoveryUsernameBookIndexRoute,
    PublicDiscoveryUsernameOfferIndexRoute:
      PublicDiscoveryUsernameOfferIndexRoute,
    PublicDiscoveryUsernameResourcesIndexRoute:
      PublicDiscoveryUsernameResourcesIndexRoute,
  }

const PublicDiscoveryUsernameRouteWithChildren =
  PublicDiscoveryUsernameRoute._addFileChildren(
    PublicDiscoveryUsernameRouteChildren,
  )

interface PublicDiscoveryStepsRouteChildren {
  PublicDiscoveryStepsIndexRoute: typeof PublicDiscoveryStepsIndexRoute
  PublicDiscoverySteps1IndexRoute: typeof PublicDiscoverySteps1IndexRoute
  PublicDiscoverySteps10IndexRoute: typeof PublicDiscoverySteps10IndexRoute
  PublicDiscoverySteps2IndexRoute: typeof PublicDiscoverySteps2IndexRoute
  PublicDiscoverySteps3IndexRoute: typeof PublicDiscoverySteps3IndexRoute
  PublicDiscoverySteps4IndexRoute: typeof PublicDiscoverySteps4IndexRoute
  PublicDiscoverySteps5IndexRoute: typeof PublicDiscoverySteps5IndexRoute
  PublicDiscoverySteps6IndexRoute: typeof PublicDiscoverySteps6IndexRoute
  PublicDiscoverySteps7IndexRoute: typeof PublicDiscoverySteps7IndexRoute
  PublicDiscoverySteps8IndexRoute: typeof PublicDiscoverySteps8IndexRoute
  PublicDiscoverySteps9IndexRoute: typeof PublicDiscoverySteps9IndexRoute
  PublicDiscoveryStepsProcessingIndexRoute: typeof PublicDiscoveryStepsProcessingIndexRoute
}

const PublicDiscoveryStepsRouteChildren: PublicDiscoveryStepsRouteChildren = {
  PublicDiscoveryStepsIndexRoute: PublicDiscoveryStepsIndexRoute,
  PublicDiscoverySteps1IndexRoute: PublicDiscoverySteps1IndexRoute,
  PublicDiscoverySteps10IndexRoute: PublicDiscoverySteps10IndexRoute,
  PublicDiscoverySteps2IndexRoute: PublicDiscoverySteps2IndexRoute,
  PublicDiscoverySteps3IndexRoute: PublicDiscoverySteps3IndexRoute,
  PublicDiscoverySteps4IndexRoute: PublicDiscoverySteps4IndexRoute,
  PublicDiscoverySteps5IndexRoute: PublicDiscoverySteps5IndexRoute,
  PublicDiscoverySteps6IndexRoute: PublicDiscoverySteps6IndexRoute,
  PublicDiscoverySteps7IndexRoute: PublicDiscoverySteps7IndexRoute,
  PublicDiscoverySteps8IndexRoute: PublicDiscoverySteps8IndexRoute,
  PublicDiscoverySteps9IndexRoute: PublicDiscoverySteps9IndexRoute,
  PublicDiscoveryStepsProcessingIndexRoute:
    PublicDiscoveryStepsProcessingIndexRoute,
}

const PublicDiscoveryStepsRouteWithChildren =
  PublicDiscoveryStepsRoute._addFileChildren(PublicDiscoveryStepsRouteChildren)

interface PublicRouteChildren {
  PublicDiscoveryUsernameRoute: typeof PublicDiscoveryUsernameRouteWithChildren
  PublicDiscoveryStepsRoute: typeof PublicDiscoveryStepsRouteWithChildren
  PublicCcosIndexRoute: typeof PublicCcosIndexRoute
  PublicDiscoveryIndexRoute: typeof PublicDiscoveryIndexRoute
  PublicCoachesCategoryIndexRoute: typeof PublicCoachesCategoryIndexRoute
  PublicCoachesCcoIndexRoute: typeof PublicCoachesCcoIndexRoute
  PublicCoachesCityIndexRoute: typeof PublicCoachesCityIndexRoute
  PublicCoachesFoundingIndexRoute: typeof PublicCoachesFoundingIndexRoute
  PublicCoachesSubcategoryIndexRoute: typeof PublicCoachesSubcategoryIndexRoute
  PublicPageNameIndexRoute: typeof PublicPageNameIndexRoute
  PublicSummitSummitIdSessionSessionIdRoute: typeof PublicSummitSummitIdSessionSessionIdRoute
  PublicCoachesCategoryCategorySlugIndexRoute: typeof PublicCoachesCategoryCategorySlugIndexRoute
  PublicCoachesCcoSlugIndexRoute: typeof PublicCoachesCcoSlugIndexRoute
  PublicCoachesCitySlugIndexRoute: typeof PublicCoachesCitySlugIndexRoute
  PublicCoachesSubcategorySubcategorySlugIndexRoute: typeof PublicCoachesSubcategorySubcategorySlugIndexRoute
  PublicCoachesCitySlugCategoryCategorySlugIndexRoute: typeof PublicCoachesCitySlugCategoryCategorySlugIndexRoute
  PublicCoachesCitySlugSubcategorySubcategorySlugIndexRoute: typeof PublicCoachesCitySlugSubcategorySubcategorySlugIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicDiscoveryUsernameRoute: PublicDiscoveryUsernameRouteWithChildren,
  PublicDiscoveryStepsRoute: PublicDiscoveryStepsRouteWithChildren,
  PublicCcosIndexRoute: PublicCcosIndexRoute,
  PublicDiscoveryIndexRoute: PublicDiscoveryIndexRoute,
  PublicCoachesCategoryIndexRoute: PublicCoachesCategoryIndexRoute,
  PublicCoachesCcoIndexRoute: PublicCoachesCcoIndexRoute,
  PublicCoachesCityIndexRoute: PublicCoachesCityIndexRoute,
  PublicCoachesFoundingIndexRoute: PublicCoachesFoundingIndexRoute,
  PublicCoachesSubcategoryIndexRoute: PublicCoachesSubcategoryIndexRoute,
  PublicPageNameIndexRoute: PublicPageNameIndexRoute,
  PublicSummitSummitIdSessionSessionIdRoute:
    PublicSummitSummitIdSessionSessionIdRoute,
  PublicCoachesCategoryCategorySlugIndexRoute:
    PublicCoachesCategoryCategorySlugIndexRoute,
  PublicCoachesCcoSlugIndexRoute: PublicCoachesCcoSlugIndexRoute,
  PublicCoachesCitySlugIndexRoute: PublicCoachesCitySlugIndexRoute,
  PublicCoachesSubcategorySubcategorySlugIndexRoute:
    PublicCoachesSubcategorySubcategorySlugIndexRoute,
  PublicCoachesCitySlugCategoryCategorySlugIndexRoute:
    PublicCoachesCitySlugCategoryCategorySlugIndexRoute,
  PublicCoachesCitySlugSubcategorySubcategorySlugIndexRoute:
    PublicCoachesCitySlugSubcategorySubcategorySlugIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

interface UserSettingsProfileRouteChildren {
  UserSettingsProfileCoachingPreferencesRoute: typeof UserSettingsProfileCoachingPreferencesRoute
  UserSettingsProfileIndexRoute: typeof UserSettingsProfileIndexRoute
}

const UserSettingsProfileRouteChildren: UserSettingsProfileRouteChildren = {
  UserSettingsProfileCoachingPreferencesRoute:
    UserSettingsProfileCoachingPreferencesRoute,
  UserSettingsProfileIndexRoute: UserSettingsProfileIndexRoute,
}

const UserSettingsProfileRouteWithChildren =
  UserSettingsProfileRoute._addFileChildren(UserSettingsProfileRouteChildren)

interface UserRouteChildren {
  UserDashboardRoute: typeof UserDashboardRoute
  UserSettingsProfileRoute: typeof UserSettingsProfileRouteWithChildren
  UserSummitAgendaRoute: typeof UserSummitAgendaRoute
  UserCoachDiscoveryIndexRoute: typeof UserCoachDiscoveryIndexRoute
  UserMessagesIndexRoute: typeof UserMessagesIndexRoute
  UserSettingsIndexRoute: typeof UserSettingsIndexRoute
  UserMessagesConversationIdIndexRoute: typeof UserMessagesConversationIdIndexRoute
  UserSettingsPasswordIndexRoute: typeof UserSettingsPasswordIndexRoute
}

const UserRouteChildren: UserRouteChildren = {
  UserDashboardRoute: UserDashboardRoute,
  UserSettingsProfileRoute: UserSettingsProfileRouteWithChildren,
  UserSummitAgendaRoute: UserSummitAgendaRoute,
  UserCoachDiscoveryIndexRoute: UserCoachDiscoveryIndexRoute,
  UserMessagesIndexRoute: UserMessagesIndexRoute,
  UserSettingsIndexRoute: UserSettingsIndexRoute,
  UserMessagesConversationIdIndexRoute: UserMessagesConversationIdIndexRoute,
  UserSettingsPasswordIndexRoute: UserSettingsPasswordIndexRoute,
}

const UserRouteWithChildren = UserRoute._addFileChildren(UserRouteChildren)

interface BlogRouteChildren {
  BlogIndexRoute: typeof BlogIndexRoute
  BlogSlugIndexRoute: typeof BlogSlugIndexRoute
  BlogMembersIndexRoute: typeof BlogMembersIndexRoute
}

const BlogRouteChildren: BlogRouteChildren = {
  BlogIndexRoute: BlogIndexRoute,
  BlogSlugIndexRoute: BlogSlugIndexRoute,
  BlogMembersIndexRoute: BlogMembersIndexRoute,
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

interface CoachBackendEditProfileOffersRouteChildren {
  CoachBackendEditProfileOffersIndexRoute: typeof CoachBackendEditProfileOffersIndexRoute
  CoachBackendEditProfileOffersOfferIdIndexRoute: typeof CoachBackendEditProfileOffersOfferIdIndexRoute
}

const CoachBackendEditProfileOffersRouteChildren: CoachBackendEditProfileOffersRouteChildren =
  {
    CoachBackendEditProfileOffersIndexRoute:
      CoachBackendEditProfileOffersIndexRoute,
    CoachBackendEditProfileOffersOfferIdIndexRoute:
      CoachBackendEditProfileOffersOfferIdIndexRoute,
  }

const CoachBackendEditProfileOffersRouteWithChildren =
  CoachBackendEditProfileOffersRoute._addFileChildren(
    CoachBackendEditProfileOffersRouteChildren,
  )

interface CoachBackendEditProfileRouteChildren {
  CoachBackendEditProfileOffersRoute: typeof CoachBackendEditProfileOffersRouteWithChildren
  CoachBackendEditProfileIndexRoute: typeof CoachBackendEditProfileIndexRoute
  CoachBackendEditProfileClientFlowIndexRoute: typeof CoachBackendEditProfileClientFlowIndexRoute
  CoachBackendEditProfileDetailsIndexRoute: typeof CoachBackendEditProfileDetailsIndexRoute
  CoachBackendEditProfileOfferIndexRoute: typeof CoachBackendEditProfileOfferIndexRoute
  CoachBackendEditProfilePersonalInfoIndexRoute: typeof CoachBackendEditProfilePersonalInfoIndexRoute
  CoachBackendEditProfileProfileIndexRoute: typeof CoachBackendEditProfileProfileIndexRoute
  CoachBackendEditProfileQualificationsIndexRoute: typeof CoachBackendEditProfileQualificationsIndexRoute
  CoachBackendEditProfileResourcesIndexRoute: typeof CoachBackendEditProfileResourcesIndexRoute
  CoachBackendEditProfileResourcesResourceIdIndexRoute: typeof CoachBackendEditProfileResourcesResourceIdIndexRoute
}

const CoachBackendEditProfileRouteChildren: CoachBackendEditProfileRouteChildren =
  {
    CoachBackendEditProfileOffersRoute:
      CoachBackendEditProfileOffersRouteWithChildren,
    CoachBackendEditProfileIndexRoute: CoachBackendEditProfileIndexRoute,
    CoachBackendEditProfileClientFlowIndexRoute:
      CoachBackendEditProfileClientFlowIndexRoute,
    CoachBackendEditProfileDetailsIndexRoute:
      CoachBackendEditProfileDetailsIndexRoute,
    CoachBackendEditProfileOfferIndexRoute:
      CoachBackendEditProfileOfferIndexRoute,
    CoachBackendEditProfilePersonalInfoIndexRoute:
      CoachBackendEditProfilePersonalInfoIndexRoute,
    CoachBackendEditProfileProfileIndexRoute:
      CoachBackendEditProfileProfileIndexRoute,
    CoachBackendEditProfileQualificationsIndexRoute:
      CoachBackendEditProfileQualificationsIndexRoute,
    CoachBackendEditProfileResourcesIndexRoute:
      CoachBackendEditProfileResourcesIndexRoute,
    CoachBackendEditProfileResourcesResourceIdIndexRoute:
      CoachBackendEditProfileResourcesResourceIdIndexRoute,
  }

const CoachBackendEditProfileRouteWithChildren =
  CoachBackendEditProfileRoute._addFileChildren(
    CoachBackendEditProfileRouteChildren,
  )

interface CoachBackendMessagesRouteChildren {
  CoachBackendMessagesIndexRoute: typeof CoachBackendMessagesIndexRoute
  CoachBackendMessagesConversationIdIndexRoute: typeof CoachBackendMessagesConversationIdIndexRoute
}

const CoachBackendMessagesRouteChildren: CoachBackendMessagesRouteChildren = {
  CoachBackendMessagesIndexRoute: CoachBackendMessagesIndexRoute,
  CoachBackendMessagesConversationIdIndexRoute:
    CoachBackendMessagesConversationIdIndexRoute,
}

const CoachBackendMessagesRouteWithChildren =
  CoachBackendMessagesRoute._addFileChildren(CoachBackendMessagesRouteChildren)

interface CoachBackendRouteChildren {
  CoachBackendEditProfileRoute: typeof CoachBackendEditProfileRouteWithChildren
  CoachBackendMessagesRoute: typeof CoachBackendMessagesRouteWithChildren
  CoachBackendBusinessIndexRoute: typeof CoachBackendBusinessIndexRoute
  CoachBackendInvoicesIndexRoute: typeof CoachBackendInvoicesIndexRoute
  CoachBackendMembershipPlansIndexRoute: typeof CoachBackendMembershipPlansIndexRoute
  CoachBackendStripeConnectIndexRoute: typeof CoachBackendStripeConnectIndexRoute
}

const CoachBackendRouteChildren: CoachBackendRouteChildren = {
  CoachBackendEditProfileRoute: CoachBackendEditProfileRouteWithChildren,
  CoachBackendMessagesRoute: CoachBackendMessagesRouteWithChildren,
  CoachBackendBusinessIndexRoute: CoachBackendBusinessIndexRoute,
  CoachBackendInvoicesIndexRoute: CoachBackendInvoicesIndexRoute,
  CoachBackendMembershipPlansIndexRoute: CoachBackendMembershipPlansIndexRoute,
  CoachBackendStripeConnectIndexRoute: CoachBackendStripeConnectIndexRoute,
}

const CoachBackendRouteWithChildren = CoachBackendRoute._addFileChildren(
  CoachBackendRouteChildren,
)

interface CoachRouteChildren {
  CoachBackendRoute: typeof CoachBackendRouteWithChildren
  CoachUnauthenticatedRoute: typeof CoachUnauthenticatedRoute
}

const CoachRouteChildren: CoachRouteChildren = {
  CoachBackendRoute: CoachBackendRouteWithChildren,
  CoachUnauthenticatedRoute: CoachUnauthenticatedRoute,
}

const CoachRouteWithChildren = CoachRoute._addFileChildren(CoachRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  UsernameRoute: UsernameRouteWithChildren,
  R404Route: R404Route,
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  UserRoute: UserRouteWithChildren,
  BlogRoute: BlogRouteWithChildren,
  CoachRoute: CoachRouteWithChildren,
  LcPaymentIndexRoute: LcPaymentIndexRoute,
  SummitIndexRoute: SummitIndexRoute,
  AdminCoachesIndexRoute: AdminCoachesIndexRoute,
  AdminFinderIndexRoute: AdminFinderIndexRoute,
  AdminIntegrationsIndexRoute: AdminIntegrationsIndexRoute,
  AdminStripeIndexRoute: AdminStripeIndexRoute,
  EmbedCoachLevelsIndexRoute: EmbedCoachLevelsIndexRoute,
  EmbedNewCoaches30dIndexRoute: EmbedNewCoaches30dIndexRoute,
  EmbedNumberOfCoachesIndexRoute: EmbedNumberOfCoachesIndexRoute,
  EmbedNumberOfUsersIndexRoute: EmbedNumberOfUsersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
const rootServerRouteChildren: RootServerRouteChildren = {
  SitemapCoachesArticlesDotxmlServerRoute:
    SitemapCoachesArticlesDotxmlServerRoute,
  SitemapCoachesDotxmlServerRoute: SitemapCoachesDotxmlServerRoute,
  SitemapGroupsDotxmlServerRoute: SitemapGroupsDotxmlServerRoute,
  UsernameSocialImageDotsvgServerRoute: UsernameSocialImageDotsvgServerRoute,
  ApiBlogCreateArticleServerRoute: ApiBlogCreateArticleServerRoute,
  ApiBackfillExpertisesIndexServerRoute: ApiBackfillExpertisesIndexServerRoute,
  ApiBatchResetClosestCityIndexServerRoute:
    ApiBatchResetClosestCityIndexServerRoute,
  ApiCoachEmbeddingsIndexServerRoute: ApiCoachEmbeddingsIndexServerRoute,
  ApiCoachJoinedCommunityIndexServerRoute:
    ApiCoachJoinedCommunityIndexServerRoute,
  ApiCoachPreProfileIndexServerRoute: ApiCoachPreProfileIndexServerRoute,
  ApiGenerateProfileIndexServerRoute: ApiGenerateProfileIndexServerRoute,
  ApiGhlCoachStatusIndexServerRoute: ApiGhlCoachStatusIndexServerRoute,
  ApiGhlContractSignedIndexServerRoute: ApiGhlContractSignedIndexServerRoute,
  ApiGhlCreateAccountIndexServerRoute: ApiGhlCreateAccountIndexServerRoute,
  ApiGhlDeletePreProfileIndexServerRoute:
    ApiGhlDeletePreProfileIndexServerRoute,
  ApiGhlEnableSaasIndexServerRoute: ApiGhlEnableSaasIndexServerRoute,
  ApiGhlMailerliteUnsubscribeIndexServerRoute:
    ApiGhlMailerliteUnsubscribeIndexServerRoute,
  ApiGhlPermanentlyDeleteProfileIndexServerRoute:
    ApiGhlPermanentlyDeleteProfileIndexServerRoute,
  ApiGhlSetUserPermissionsIndexServerRoute:
    ApiGhlSetUserPermissionsIndexServerRoute,
  ApiGhlSummitRegistrationIndexServerRoute:
    ApiGhlSummitRegistrationIndexServerRoute,
  ApiMailerliteWebhookIndexServerRoute: ApiMailerliteWebhookIndexServerRoute,
  ApiStripeWebhookConnectIndexServerRoute:
    ApiStripeWebhookConnectIndexServerRoute,
  ApiStripeWebhookDirectIndexServerRoute:
    ApiStripeWebhookDirectIndexServerRoute,
  ApiSummitOrderBumpWebhookIndexServerRoute:
    ApiSummitOrderBumpWebhookIndexServerRoute,
  ApiSummitSyncIndexServerRoute: ApiSummitSyncIndexServerRoute,
  ApiSummitVipWebhookIndexServerRoute: ApiSummitVipWebhookIndexServerRoute,
  ApiLeadconnectorCreatePaymentConfigIndexServerRoute:
    ApiLeadconnectorCreatePaymentConfigIndexServerRoute,
  ApiLeadconnectorInitIndexServerRoute: ApiLeadconnectorInitIndexServerRoute,
  ApiLeadconnectorOauthIndexServerRoute: ApiLeadconnectorOauthIndexServerRoute,
  ApiLeadconnectorQueryIndexServerRoute: ApiLeadconnectorQueryIndexServerRoute,
  ApiLeadconnectorWebhookIndexServerRoute:
    ApiLeadconnectorWebhookIndexServerRoute,
  ApiProxyKeyIndexServerRoute: ApiProxyKeyIndexServerRoute,
  PublicSummitSummitIdSessionSessionIdSocialImageDotsvgServerRoute:
    PublicSummitSummitIdSessionSessionIdSocialImageDotsvgServerRoute,
}
export const serverRouteTree = rootServerRouteImport
  ._addFileChildren(rootServerRouteChildren)
  ._addFileTypes<FileServerRouteTypes>()
